var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSalaryhr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2475 1650",
    width: 406,
    height: 306,
    style: {
      enableBackground: "new 0 0 2475 1650"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 201.7221,
    y1: 804.7385,
    x2: 2356.688,
    y2: 804.7385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M569.42,159.923c-160.393,132.558,54.015,302.711-57.062,376.989 c-111.077,74.279-571.101,219.146-107.84,506.541s494.806,618.33,825.516,436.359c330.71-181.972,427.754-160.131,699.903-37.112 s500.881-254.132,404.168-481.285c-96.713-227.153-242.191-233.612-131.757-378.676s-62.267-546.49-442.414-236.264 s-618.091,78.617-659.833-37.404S822.894-49.563,569.42,159.923z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063628965523990727500000007730178705993703835_",
    gradientUnits: "userSpaceOnUse",
    x1: 2368.0989,
    y1: 447.7803,
    x2: 1046.5692,
    y2: 2182.7119,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063628965523990727500000007730178705993703835_)"
    },
    d: "M1866.795,448.716l42.643,2.223 c21.091,1.1,37.603,18.568,37.513,39.688l-4.286,1011.794c-0.098,23.04-18.936,41.596-41.975,41.345l-292.791-3.187 L1866.795,448.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1355.55,454.912l540.138-31.784c11.173-0.658,20.531,8.357,20.29,19.547l-22.424,1042.791 c-0.479,22.255-19.003,39.855-41.254,39.193l-379.998-11.292L1355.55,454.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1384.627,476.529l474.67-65.624c12.202-1.687,23.049,7.873,22.907,20.191l-12.107,1051.65 c-0.171,14.828-11.929,26.922-26.746,27.511l-349.575,13.889L1384.627,476.529z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168116688915853128970000004888239371682410135_",
    gradientUnits: "userSpaceOnUse",
    x1: 1635.6045,
    y1: 973.756,
    x2: 978.5392,
    y2: 1003.7587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168116688915853128970000004888239371682410135_)"
    },
    d: "M1259.157,425.571l520.765-37.895 c25.954-1.888,48.122,18.509,48.394,44.53l11.241,1073.664c0.228,21.773-17.237,39.608-39.01,39.836l-480.449,5.03 c-22.669,0.237-41.565-17.297-43.021-39.92l-66.263-1029.788C1208.973,452.407,1230.551,427.653,1259.157,425.571z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096749227082188596500000005223078968090432397_",
    gradientUnits: "userSpaceOnUse",
    x1: 1736.9462,
    y1: 737.0455,
    x2: 631.3813,
    y2: 1040.7345,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096749227082188596500000005223078968090432397_)"
    },
    d: "M1853.598,809.786l-42.653,0.446 c-10.591,0.111-19.266-8.385-19.377-18.976l-2.953-282.044c-0.111-10.591,8.385-19.267,18.976-19.377l42.653-0.447 c10.591-0.111,19.266,8.385,19.377,18.976l2.953,282.044C1872.685,800.999,1864.189,809.675,1853.598,809.786z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2136.516,339.923c-62.814,20.723-424.257,159.228-377.048,589.487 c0,0,257.48-17.694,383.837-581.414C2144.411,343.065,2140.62,338.569,2136.516,339.923z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M2097.929,403.894c0,0-24.98,23.843-60.972,61.112c-8.99,9.323-18.685,19.466-28.834,30.293 c-10.159,10.817-20.787,22.303-31.666,34.289c-10.896,11.971-22.011,24.469-33.217,37.243 c-11.154,12.819-22.425,25.894-33.469,39.156c-5.544,6.612-11.051,13.255-16.456,19.937c-5.463,6.635-10.793,13.332-16.07,19.984 c-10.573,13.29-20.729,26.559-30.407,39.507c-4.86,6.458-9.462,12.937-14.063,19.207c-4.551,6.307-8.861,12.575-13.134,18.622 c-4.22,6.084-8.182,12.095-12.091,17.858c-3.88,5.782-7.434,11.492-10.952,16.905c-3.555,5.392-6.632,10.756-9.737,15.75 c-1.519,2.517-3.049,4.941-4.445,7.348c-1.384,2.414-2.728,4.759-4.031,7.031c-5.316,9.032-9.53,17.124-13.066,23.751 c-1.812,3.293-3.263,6.312-4.539,8.932c-1.281,2.618-2.371,4.844-3.255,6.649c-1.767,3.609-2.71,5.534-2.71,5.534l-0.068,0.139 c-0.978,1.998-3.392,2.825-5.39,1.846c-1.998-0.979-2.825-3.392-1.847-5.39l0.015-0.031c0,0,0.973-1.947,2.798-5.597 c0.912-1.826,2.038-4.076,3.361-6.724c1.318-2.649,2.819-5.702,4.68-9.02c3.637-6.683,7.976-14.844,13.421-23.922 c1.336-2.284,2.714-4.642,4.133-7.07c1.431-2.42,2.994-4.851,4.548-7.378c3.174-5.012,6.328-10.401,9.953-15.802 c3.589-5.424,7.221-11.149,11.176-16.936c3.983-5.767,8.023-11.786,12.319-17.869c4.348-6.045,8.735-12.313,13.363-18.613 c4.676-6.262,9.357-12.734,14.292-19.179c9.83-12.923,20.137-26.157,30.857-39.403c5.352-6.629,10.755-13.303,16.29-19.911 c5.478-6.656,11.056-13.27,16.67-19.854c11.185-13.203,22.591-26.214,33.877-38.965c11.337-12.706,22.578-25.135,33.594-37.034 c10.999-11.915,21.74-23.33,32.005-34.078c10.255-10.757,20.049-20.833,29.13-30.093c36.352-37.016,61.589-60.701,61.589-60.701 c0.686-0.646,1.766-0.614,2.413,0.072C2098.636,402.172,2098.604,403.247,2097.929,403.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2253.552,382.937c-88.574,28.456-597.26,215.106-507.854,723.91 c0,0,366.519-36.67,517.956-714.721C2264.979,386.194,2259.339,381.078,2253.552,382.937z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M2201.139,461.246c0,0-33.668,29.152-82.4,74.857c-12.187,11.42-25.307,23.88-39.086,37.159 c-13.757,13.302-28.227,27.369-42.992,42.123c-14.819,14.702-29.932,30.091-45.203,45.809 c-7.579,7.913-15.217,15.889-22.886,23.896c-7.57,8.099-15.26,16.146-22.785,24.346c-7.522,8.202-15.12,16.334-22.493,24.61 c-7.429,8.226-14.81,16.436-21.998,24.699c-3.61,4.117-7.206,8.218-10.784,12.297c-3.526,4.125-7.034,8.229-10.521,12.308 c-7.023,8.117-13.764,16.298-20.418,24.324c-13.294,16.064-25.826,31.847-37.448,47.006 c-11.605,15.171-22.312,29.711-31.843,43.369c-4.881,6.752-9.268,13.415-13.489,19.719c-2.111,3.151-4.167,6.222-6.166,9.206 c-1.962,3.008-3.78,5.985-5.589,8.839c-3.564,5.74-7.031,11.036-10.002,16.067c-2.943,5.047-5.645,9.684-8.087,13.87 c-1.216,2.096-2.367,4.079-3.45,5.946c-1.014,1.903-1.964,3.687-2.848,5.346c-1.768,3.318-3.272,6.14-4.492,8.429 c-2.439,4.576-3.74,7.017-3.74,7.017l-0.08,0.151c-1.047,1.964-3.487,2.707-5.45,1.661c-1.963-1.047-2.707-3.487-1.66-5.451 l0.012-0.022c0,0,1.335-2.467,3.837-7.091c1.251-2.312,2.795-5.163,4.609-8.515c0.907-1.676,1.882-3.477,2.923-5.399 c1.107-1.881,2.284-3.88,3.528-5.992c2.496-4.217,5.26-8.887,8.268-13.971c3.037-5.065,6.566-10.383,10.202-16.153 c1.844-2.867,3.7-5.859,5.698-8.879c2.034-2.995,4.126-6.075,6.273-9.238c4.294-6.324,8.76-13.008,13.714-19.769 c9.684-13.686,20.546-28.236,32.305-43.404c11.776-15.155,24.463-30.922,37.908-46.954c6.73-8.011,13.547-16.175,20.644-24.27 c3.524-4.069,7.069-8.162,10.632-12.276c3.614-4.068,7.246-8.156,10.893-12.261c7.261-8.237,14.714-16.42,22.214-24.615 c7.444-8.248,15.111-16.348,22.702-24.517c7.593-8.168,15.351-16.179,22.987-24.244c7.734-7.971,15.438-15.91,23.081-23.788 c15.398-15.643,30.634-30.955,45.568-45.58c14.882-14.679,29.46-28.668,43.32-41.895c13.882-13.204,27.096-25.592,39.371-36.945 c49.079-45.432,82.993-74.414,82.993-74.414c0.715-0.614,1.793-0.531,2.406,0.184 C2201.929,459.556,2201.847,460.63,2201.139,461.246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000061431832563170844550000003351195174095732901_",
    gradientUnits: "userSpaceOnUse",
    x1: 2527.7034,
    y1: 672.6789,
    x2: 1458.9921,
    y2: 2075.7051,
    gradientTransform: "matrix(0.9999 -0.0105 0.0105 0.9999 -22.683 -37.8145)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000061431832563170844550000003351195174095732901_)"
    },
    d: "M2121.163,659.738l34.485,1.798 c17.057,0.889,30.409,15.016,30.337,32.095l-3.466,818.23c-0.079,18.633-15.313,33.638-33.945,33.435l-236.778-2.577 L2121.163,659.738z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1707.723,664.749l436.806-25.703c9.036-0.532,16.603,6.759,16.408,15.808l-18.134,843.297 c-0.387,17.997-15.368,32.23-33.361,31.695l-307.301-9.132L1707.723,664.749z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1731.238,682.23l383.862-53.069c9.868-1.364,18.639,6.367,18.524,16.328l-9.791,850.461 c-0.138,11.991-9.647,21.772-21.629,22.248l-282.698,11.232L1731.238,682.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028327125907968398500000006865776402827249592_",
    gradientUnits: "userSpaceOnUse",
    x1: 2336.019,
    y1: 1050.9885,
    x2: 1723.9558,
    y2: 1104.9946
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028327125907968398500000006865776402827249592_)"
    },
    d: "M1629.77,641.021l421.139-30.646 c20.989-1.527,38.916,14.968,39.136,36.011l9.091,868.264c0.184,17.607-13.94,32.03-31.547,32.215l-388.535,4.068 c-18.332,0.192-33.613-13.987-34.79-32.283l-53.587-832.781C1589.187,662.723,1606.637,642.704,1629.77,641.021z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000021799978731731165900000013690757426687442318_",
    gradientUnits: "userSpaceOnUse",
    x1: 2314.1155,
    y1: 802.7526,
    x2: 1702.053,
    y2: 856.7587
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000021799978731731165900000013690757426687442318_)"
    },
    d: "M2116.48,951.669l-46.472,0.487 c-5.257,0.055-9.563-4.162-9.618-9.419l-2.514-240.066c-0.055-5.257,4.162-9.563,9.419-9.618l46.471-0.487 c5.257-0.055,9.563,4.162,9.618,9.419l2.513,240.065C2125.954,947.308,2121.737,951.614,2116.48,951.669z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028325474203631163880000004914738476574916753_",
    gradientUnits: "userSpaceOnUse",
    x1: 1848.3909,
    y1: 1049.094,
    x2: 2121.4626,
    y2: 1310.7876
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028325474203631163880000004914738476574916753_)"
    },
    d: "M1731.571,1115.223l4.019,157.483 c0.312,12.233,15.467,22.042,34.053,22.042h469.576c18.81,0,34.058-10.037,34.058-22.419v-147.393 c0-12.099-14.585-22.015-32.956-22.407l-473.595-10.09C1747.27,1092.025,1731.244,1102.411,1731.571,1115.223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M1770.441,1130.568l10.189,144.819c0.391,5.562,7.433,9.91,15.89,9.811 l427.594-4.956c8.524-0.099,15.356-4.676,15.356-10.287V1144.36c0-5.484-6.536-10.005-14.858-10.276l-437.784-14.268 C1777.617,1119.515,1770.015,1124.503,1770.441,1130.568z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006700593284969281320000007425378346716513412_",
    gradientUnits: "userSpaceOnUse",
    x1: 1804.54,
    y1: 1149.3647,
    x2: 2193.3459,
    y2: 1149.3647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006700593284969281320000007425378346716513412_)"
    },
    d: "M1804.54,1144.149v10.432 c0,3.677,4.578,6.642,10.164,6.582l368.804-3.961c5.459-0.058,9.838-2.988,9.838-6.582l0,0c0-3.568-4.317-6.486-9.734-6.581 l-368.804-6.471C1809.182,1137.469,1804.54,1140.444,1804.54,1144.149z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113318011684934205170000006760137399486434455_",
    gradientUnits: "userSpaceOnUse",
    x1: 1810.0459,
    y1: 1187.6049,
    x2: 2181.313,
    y2: 1187.6049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113318011684934205170000006760137399486434455_)"
    },
    d: "M1810.046,1183.554v9.569 c0,3.725,4.692,6.708,10.349,6.579l351.265-8.054c5.384-0.123,9.653-3.032,9.653-6.579v-2.983c0-3.652-4.516-6.606-10.064-6.583 l-351.265,1.468C1814.485,1176.995,1810.046,1179.935,1810.046,1183.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M859.92,1567.833c0,0-48.804-313.938-242.449-366.939 c-185.757-50.842-211.767,40.719-316.319-61.528c-4.773-4.668-12.782-0.807-12.05,5.829 c7.857,71.177,49.717,308.534,258.535,306.806C788.926,1450.004,859.92,1567.833,859.92,1567.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M336.021,1205.3c0,0,0.294,0.562,0.914,1.524c0.621,0.964,1.498,2.403,2.851,4.233 c2.544,3.728,6.785,8.878,12.502,15.128c1.449,1.544,3.079,3.08,4.729,4.74c1.699,1.613,3.325,3.455,5.303,5.086 c3.9,3.312,7.869,7.176,12.666,10.655c2.342,1.802,4.76,3.663,7.248,5.579c2.545,1.839,5.277,3.576,8.017,5.444 c1.377,0.925,2.771,1.86,4.183,2.807c1.411,0.949,2.823,1.934,4.356,2.768c3.014,1.747,6.099,3.534,9.249,5.36 c1.574,0.913,3.164,1.836,4.77,2.767c1.613,0.919,3.334,1.682,5.021,2.544c3.395,1.679,6.854,3.391,10.373,5.132 c1.775,0.836,3.494,1.826,5.356,2.556c1.844,0.765,3.703,1.537,5.575,2.316c3.744,1.556,7.544,3.136,11.398,4.737l2.898,1.205 c0.98,0.376,1.989,0.69,2.987,1.04c2.002,0.684,4.017,1.371,6.045,2.064c4.053,1.384,8.155,2.785,12.302,4.201l3.121,1.055 l3.2,0.87c2.138,0.581,4.287,1.166,6.447,1.753c4.317,1.176,8.675,2.361,13.07,3.557c4.359,1.326,8.918,2.037,13.436,3.034 c4.531,0.937,9.095,1.883,13.687,2.833c2.298,0.463,4.592,0.98,6.911,1.403c2.335,0.339,4.677,0.681,7.025,1.022 c4.694,0.685,9.411,1.371,14.148,2.062c4.774,0.676,9.401,1.414,14.341,2.046c4.811,0.645,9.636,1.292,14.47,1.94 c4.867,0.8,9.743,1.603,14.625,2.405l14.533,2.856c19.325,4.105,38.437,9.477,56.744,16.316 c18.297,6.856,35.729,15.283,51.724,24.96c8.042,4.771,15.586,10.057,22.867,15.364c7.136,5.497,14.022,11.025,20.318,16.863 c12.704,11.556,23.666,23.595,32.957,35.292c9.324,11.681,17.114,22.925,23.707,33.035c6.585,10.118,12.002,19.1,16.402,26.501 c8.668,14.809,13.621,23.27,13.621,23.27c1.946,3.324,0.828,7.596-2.496,9.542c-3.324,1.946-7.596,0.828-9.542-2.496 c-0.014-0.025-0.028-0.049-0.042-0.073l-0.025-0.045c0,0-4.789-8.516-13.169-23.418c-4.224-7.395-9.4-16.318-15.656-26.305 c-6.264-9.979-13.635-21.013-22.434-32.438c-8.769-11.443-19.096-23.177-31.09-34.473c-5.943-5.709-12.457-11.119-19.215-16.52 c-6.904-5.211-14.062-10.421-21.729-15.147c-15.241-9.584-31.95-18.032-49.624-25.006c-17.683-6.957-36.266-12.534-55.158-16.89 l-14.218-3.05c-4.753-0.867-9.501-1.733-14.239-2.598c-4.816-0.73-9.623-1.459-14.416-2.186c-4.672-0.681-9.586-1.542-14.338-2.3 c-4.785-0.782-9.551-1.561-14.293-2.335c-2.37-0.389-4.734-0.775-7.092-1.161c-2.343-0.469-4.664-1.032-6.985-1.541 c-4.638-1.044-9.248-2.082-13.825-3.111c-4.562-1.09-9.156-1.892-13.564-3.311c-4.437-1.291-8.838-2.569-13.197-3.836 c-2.178-0.633-4.346-1.264-6.504-1.892l-3.227-0.939l-3.152-1.124c-4.185-1.51-8.325-3.004-12.415-4.48 c-2.044-0.738-4.076-1.472-6.094-2.2c-1.006-0.372-2.022-0.708-3.01-1.108l-2.925-1.275c-3.885-1.693-7.717-3.364-11.492-5.009 c-1.886-0.823-3.758-1.64-5.616-2.449c-1.873-0.774-3.61-1.81-5.398-2.69c-3.544-1.83-7.027-3.63-10.447-5.396 c-1.698-0.905-3.427-1.71-5.052-2.673c-1.617-0.975-3.219-1.94-4.804-2.896c-3.168-1.91-6.27-3.781-9.302-5.61 c-1.54-0.875-2.962-1.901-4.381-2.89c-1.42-0.989-2.822-1.965-4.206-2.929c-2.754-1.948-5.496-3.761-8.052-5.677 c-2.499-1.992-4.927-3.928-7.28-5.804c-4.809-3.62-8.799-7.63-12.704-11.069c-1.979-1.693-3.615-3.603-5.316-5.277 c-1.655-1.723-3.284-3.314-4.736-4.916c-5.732-6.485-9.968-11.817-12.535-15.718c-1.344-1.885-2.276-3.465-2.917-4.506 c-0.643-1.045-0.907-1.575-0.907-1.575l-0.051-0.101c-0.384-0.771-0.071-1.707,0.7-2.091 C334.705,1204.249,335.628,1204.551,336.021,1205.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M870.391,1479.404l-21.622-6.58c-26.338-149.18-119.009-412.381-283.714-450.012 c-111.565-25.49-162.093-71.954-183.661-192.333c-14.389-80.307-53.981-128.566-78.747-151.796 c-5.036-4.723-0.641-13.058,6.099-11.561c67.897,15.078,247.366,64.916,353.941,187.841 C796.101,1008.844,870.391,1479.404,870.391,1479.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M426.536,742.086c0,0,0.197,0.053,0.586,0.157c0.384,0.097,0.967,0.256,1.771,0.512 c0.795,0.245,1.782,0.549,2.956,0.911c1.128,0.397,2.434,0.859,3.914,1.381c2.985,0.986,6.498,2.516,10.69,4.204 c2.103,0.831,4.256,1.928,6.612,2.987c2.325,1.115,4.872,2.164,7.423,3.526c5.095,2.732,10.908,5.473,16.848,9.109 c3.007,1.756,6.137,3.584,9.384,5.48c3.152,2.041,6.418,4.156,9.792,6.342c13.544,8.683,27.999,19.647,43.318,32.126 c1.962,1.506,3.811,3.18,5.698,4.849c1.888,1.668,3.796,3.352,5.721,5.052c3.851,3.402,7.774,6.866,11.764,10.391 c7.595,7.45,15.585,15.023,23.545,23.053c3.858,4.13,7.769,8.317,11.728,12.556c1.98,2.12,3.971,4.253,5.974,6.398 c1.998,2.15,4.056,4.271,5.932,6.57c3.841,4.521,7.725,9.09,11.645,13.705c1.96,2.307,3.93,4.625,5.909,6.955 c1.954,2.348,4.031,4.617,5.864,7.094c7.536,9.751,15.198,19.665,22.954,29.701c7.3,10.366,14.688,20.859,22.136,31.435 c0.954,1.371,1.811,2.538,2.847,4.079l2.597,4.086c1.733,2.726,3.469,5.457,5.207,8.191c3.477,5.47,6.964,10.957,10.459,16.453 l5.246,8.252c1.675,2.816,3.277,5.699,4.92,8.548c3.267,5.715,6.537,11.437,9.807,17.159l4.904,8.585 c1.642,2.858,3.295,5.71,4.752,8.647c3.016,5.828,6.029,11.652,9.035,17.465c3.007,5.813,6.008,11.615,9,17.399 c2.845,5.855,5.561,11.75,8.333,17.592c5.49,11.706,11.122,23.241,15.974,34.948c2.509,5.818,5.004,11.6,7.48,17.341 c1.238,2.871,2.472,5.731,3.701,8.581c1.148,2.882,2.292,5.753,3.432,8.611c4.49,11.46,9.112,22.655,13.261,33.751 c4.07,11.127,8.052,22.012,11.928,32.609c3.623,10.685,7.147,21.079,10.556,31.132c3.319,10.084,6.306,19.897,9.293,29.281 c5.751,18.835,10.804,36.171,14.946,51.633c2.158,7.706,4.021,14.964,5.721,21.681c1.739,6.707,3.292,12.88,4.6,18.483 c2.727,11.174,4.662,20.015,5.984,26.056c1.267,6.095,1.943,9.346,1.943,9.346c0.784,3.771-1.637,7.462-5.408,8.246 c-3.771,0.784-7.463-1.637-8.247-5.407l-0.012-0.059l-0.04-0.205c0,0-0.628-3.157-1.805-9.077 c-1.247-5.946-3.079-14.69-5.682-25.772c-1.244-5.553-2.729-11.678-4.394-18.339c-1.625-6.67-3.407-13.877-5.481-21.537 c-3.971-15.365-8.833-32.605-14.373-51.34c-2.881-9.334-5.759-19.099-8.964-29.131c-3.294-10.005-6.7-20.349-10.201-30.982 c-3.753-10.546-7.609-21.38-11.549-32.453c-4.019-11.045-8.505-22.183-12.859-33.592c-1.105-2.846-2.214-5.703-3.328-8.572 c-1.194-2.836-2.392-5.682-3.595-8.538c-2.405-5.714-4.828-11.469-7.266-17.259c-4.71-11.658-10.191-23.13-15.53-34.782 c-2.696-5.813-5.336-11.682-8.105-17.51c-2.914-5.755-5.836-11.526-8.763-17.309c-2.928-5.784-5.861-11.58-8.798-17.381 c-1.422-2.931-3.023-5.748-4.614-8.572l-4.752-8.489c-3.168-5.661-6.336-11.323-9.501-16.979 c-1.594-2.824-3.137-5.667-4.771-8.472l-5.173-8.299c-3.446-5.527-6.885-11.044-10.313-16.544 c-1.714-2.75-3.426-5.496-5.135-8.238l-2.561-4.108l-2.656-3.864c-7.283-10.54-14.509-20.996-21.648-31.327 c-7.588-9.999-15.084-19.877-22.458-29.593c-1.793-2.471-3.826-4.728-5.738-7.067c-1.936-2.32-3.864-4.629-5.782-6.928 c-3.837-4.598-7.638-9.151-11.397-13.657c-1.836-2.293-3.85-4.403-5.805-6.544c-1.961-2.137-3.91-4.26-5.848-6.372 c-3.875-4.224-7.704-8.396-11.48-12.513c-7.792-7.996-15.611-15.539-23.046-22.965c-3.905-3.51-7.744-6.961-11.512-10.347 c-1.884-1.694-3.751-3.372-5.599-5.034c-1.847-1.662-3.657-3.333-5.576-4.831c-14.986-12.424-29.126-23.351-42.352-31.992 c-3.295-2.177-6.485-4.283-9.564-6.316c-3.167-1.887-6.219-3.705-9.152-5.452c-5.8-3.624-11.446-6.339-16.408-9.06 c-2.485-1.357-4.948-2.391-7.205-3.501c-2.282-1.05-4.381-2.145-6.406-2.965c-4.039-1.665-7.448-3.19-10.282-4.149 c-1.407-0.511-2.649-0.963-3.721-1.353c-1.057-0.336-1.947-0.62-2.663-0.849c-0.702-0.234-1.276-0.396-1.671-0.501 c-0.388-0.107-0.585-0.161-0.585-0.161l-0.043-0.013c-1.752-0.484-2.779-2.297-2.294-4.048 C422.997,742.647,424.794,741.622,426.536,742.086z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M883.636,1456.079c-1.255,4.439-7.713,3.913-8.238-0.67 c-9.336-81.454-55.293-437.106-162.437-601.874c-120.027-184.579-307.05-353.532-2.445-570.386 c3.754-2.672,8.884,0.522,8.115,5.065c-4.361,25.767-7.683,86.856,40.358,148.567c63.212,81.196,100.707,236.721,28.439,419.202 C787.428,855.983,920.725,1324.928,883.636,1456.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE5FE"
    },
    d: "M680.456,351.816c0,0-0.393,0.347-1.155,1.02c-0.735,0.643-1.838,1.719-3.248,3.104 c-2.812,2.805-6.76,7.142-11.368,13.007c-4.643,5.836-9.752,13.362-14.918,22.384c-2.663,4.469-5.062,9.463-7.68,14.673 c-2.323,5.354-4.906,10.919-7.016,16.969c-0.561,1.498-1.128,3.012-1.7,4.541c-0.558,1.534-0.996,3.127-1.508,4.711 c-0.959,3.188-2.072,6.394-2.958,9.728c-0.837,3.346-1.689,6.75-2.554,10.206c-0.473,1.717-0.798,3.483-1.125,5.263 c-0.336,1.777-0.675,3.566-1.016,5.367c-0.341,1.801-0.685,3.614-1.031,5.439c-0.313,1.831-0.497,3.696-0.755,5.559 c-0.464,3.735-1.007,7.505-1.425,11.33c-0.454,7.693-1.321,15.521-1.191,23.539c-0.496,16.011,1.031,32.548,2.944,49.243 c0.675,4.154,1.352,8.324,2.032,12.507c0.689,4.18,1.277,8.387,2.286,12.533c0.91,4.161,1.822,8.331,2.735,12.504 c0.484,2.081,0.85,4.188,1.43,6.247l1.7,6.189c2.283,8.249,4.383,16.543,7.233,24.594c2.688,8.095,5.189,16.211,8.382,24.029 c5.783,15.843,12.592,31.007,19.194,45.651c3.547,7.214,7.034,14.309,10.448,21.253c0.866,1.729,1.671,3.476,2.574,5.164 c0.916,1.682,1.826,3.353,2.731,5.015c1.809,3.323,3.596,6.605,5.359,9.843c6.836,13.064,14.214,24.921,20.776,35.994 c1.656,2.759,3.277,5.461,4.862,8.102c1.677,2.586,3.316,5.112,4.913,7.576c3.194,4.925,6.223,9.597,9.07,13.987 c5.574,8.855,10.92,16.263,15.219,22.429c8.616,12.317,13.54,19.355,13.54,19.355l0.134,0.191 c2.208,3.156,1.439,7.504-1.717,9.712c-3.156,2.207-7.504,1.439-9.712-1.718c-0.017-0.024-0.053-0.078-0.07-0.101 c0,0-4.856-7.208-13.353-19.824c-4.238-6.314-9.504-13.897-14.996-22.968c-2.803-4.497-5.786-9.28-8.93-14.324 c-1.572-2.521-3.184-5.107-4.834-7.754c-1.559-2.705-3.154-5.472-4.783-8.299c-6.454-11.342-13.703-23.474-20.411-36.857 c-1.729-3.315-3.482-6.675-5.256-10.077c-0.887-1.701-1.779-3.411-2.676-5.133c-0.885-1.727-1.674-3.518-2.522-5.289 c-3.34-7.11-6.752-14.375-10.222-21.762c-6.451-15.002-13.087-30.524-18.69-46.755c-3.099-7.999-5.51-16.322-8.098-24.611 c-2.749-8.239-4.75-16.745-6.925-25.192l-1.618-6.337c-0.553-2.109-0.892-4.271-1.348-6.402 c-0.856-4.275-1.711-8.546-2.564-12.809c-0.95-4.243-1.48-8.559-2.108-12.841c-0.617-4.283-1.232-8.553-1.845-12.807 c-1.661-17.113-2.911-34.035-2.119-50.432c0.018-8.2,1.039-16.222,1.65-24.083c0.497-3.914,1.12-7.771,1.665-11.588 c0.298-1.905,0.522-3.809,0.876-5.68c0.387-1.865,0.772-3.718,1.154-5.559c0.382-1.841,0.762-3.667,1.139-5.482 c0.368-1.816,0.734-3.618,1.249-5.373c0.949-3.527,1.884-7,2.804-10.415c0.969-3.4,2.166-6.672,3.208-9.92 c0.553-1.614,1.033-3.236,1.632-4.799c0.614-1.557,1.223-3.1,1.825-4.625c2.274-6.159,5.021-11.824,7.501-17.262 c2.777-5.299,5.328-10.364,8.138-14.901c5.46-9.153,10.833-16.769,15.707-22.682c4.84-5.941,8.983-10.331,11.956-13.194 c1.505-1.426,2.644-2.5,3.496-3.222c0.82-0.697,1.243-1.056,1.243-1.056c0.869-0.739,2.173-0.634,2.911,0.235 c0.73,0.859,0.636,2.142-0.205,2.885L680.456,351.816z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1528.555,1567.833H972.757c-17.723,0-32.091-14.368-32.091-32.091v-536.65 c0-17.69,14.315-32.043,32.005-32.091l560.242-1.504c17.824-0.048,32.271,14.438,32.176,32.262l-4.445,538.154 C1560.551,1553.569,1546.212,1567.833,1528.555,1567.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1501.319,1006.573l-496.973,3.06c-17.964,0.111-32.445,14.749-32.361,32.712l3.468,451.353 c0.082,17.693,14.277,32.083,31.968,32.405l482.87,8.81c18.034,0.329,32.9-14.065,33.153-32.101l10.635-463.222 C1534.334,1021.352,1519.56,1006.461,1501.319,1006.573z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039831607442675542380000012877436073200292782_",
    gradientUnits: "userSpaceOnUse",
    x1: 1078.7158,
    y1: 1050.1453,
    x2: 1481.1127,
    y2: 1050.1453
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039831607442675542380000012877436073200292782_)"
    },
    d: "M1481.113,1048.432v3.426 c0,5.38-4.361,9.741-9.741,9.741h-382.914c-5.38,0-9.741-4.361-9.741-9.741v-3.426c0-5.38,4.361-9.741,9.741-9.741h382.914 C1476.751,1038.691,1481.113,1043.052,1481.113,1048.432z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136376915509752638450000001700134140362749611_",
    gradientUnits: "userSpaceOnUse",
    x1: 1084.0428,
    y1: 1094.052,
    x2: 1438.4036,
    y2: 1094.052
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136376915509752638450000001700134140362749611_)"
    },
    d: "M1438.389,1091.528L1438.389,1091.528 c-0.276,5.099-4.444,9.12-9.549,9.213l-334.878,6.103c-5.448,0.099-9.919-4.29-9.919-9.74v-0.795c0-5.32,4.268-9.656,9.587-9.74 l334.878-5.308C1434.155,1081.171,1438.695,1085.888,1438.389,1091.528z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094583805655759070410000015236506297928496771_",
    gradientUnits: "userSpaceOnUse",
    x1: 992.4631,
    y1: 1319.595,
    x2: 1510.6006,
    y2: 1319.595
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094583805655759070410000015236506297928496771_)"
    },
    d: "M1472.573,1508.799 c-0.111,0-0.22,0-0.33-0.002l-452.939-5.436c-7.291-0.087-14.102-3.018-19.178-8.253c-5.076-5.235-7.796-12.135-7.657-19.426 l11.657-318.714c0.135-7.187,3.092-13.955,8.322-18.987c5.229-5.031,12.086-7.671,19.365-7.586l452.152,8.8 c14.951,0.291,26.898,12.692,26.632,27.644c0,0.024-0.001,0.045-0.001,0.069l-10.866,315.277 C1499.468,1496.896,1487.316,1508.799,1472.573,1508.799z M1031.271,1138.448c-4.963,0-9.65,1.887-13.237,5.338 c-3.679,3.539-5.758,8.301-5.855,13.406l-11.657,318.714c-0.094,5.058,1.818,9.91,5.389,13.593 c3.57,3.681,8.361,5.743,13.489,5.804l452.939,5.436c0.078,0.002,0.155,0.002,0.233,0.002c10.37,0,18.917-8.371,19.102-18.767 l10.866-315.311c0.169-10.504-8.227-19.208-18.732-19.41l-452.152-8.8C1031.527,1138.448,1031.399,1138.448,1031.271,1138.448z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115495951481976754320000002567679840299926699_",
    gradientUnits: "userSpaceOnUse",
    x1: 1003.3863,
    y1: 1195.9017,
    x2: 1504.7303,
    y2: 1195.9017
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000115495951481976754320000002567679840299926699_)"
    },
    d: "M1500.701,1199.931h-493.286 c-2.225,0-4.029-1.804-4.029-4.029s1.804-4.029,4.029-4.029h493.286c2.225,0,4.029,1.804,4.029,4.029 S1502.926,1199.931,1500.701,1199.931z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000132788586481041244740000016954271963985431709_",
    gradientUnits: "userSpaceOnUse",
    x1: 589.8278,
    y1: 1336.4629,
    x2: 1069.537,
    y2: 1336.4629
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000132788586481041244740000016954271963985431709_)"
    },
    d: "M1041.469,1567.833H614.481 c-13.616,0-24.654-11.038-24.654-24.654v-412.277c0-13.59,10.998-24.617,24.587-24.654l430.402-1.155 c13.693-0.037,24.792,11.092,24.719,24.785l-3.415,413.433C1066.05,1556.875,1055.033,1567.833,1041.469,1567.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1020.545,1136.649L638.75,1139c-13.801,0.085-24.925,11.33-24.861,25.131l2.664,346.748 c0.063,13.592,10.968,24.647,24.559,24.895l370.961,6.768c13.855,0.253,25.275-10.805,25.469-24.661l8.17-355.867 C1045.909,1148.003,1034.558,1136.563,1020.545,1136.649z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050642524895439550810000005630811342982748558_",
    gradientUnits: "userSpaceOnUse",
    x1: 695.8832,
    y1: 1170.1233,
    x2: 1005.0218,
    y2: 1170.1233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050642524895439550810000005630811342982748558_)"
    },
    d: "M1005.022,1168.807v2.632 c0,4.133-3.35,7.484-7.484,7.484H703.367c-4.133,0-7.484-3.35-7.484-7.484v-2.632c0-4.133,3.351-7.484,7.484-7.484h294.171 C1001.671,1161.323,1005.022,1164.674,1005.022,1168.807z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178170532202530042390000016175667388643969193_",
    gradientUnits: "userSpaceOnUse",
    x1: 699.9757,
    y1: 1203.8542,
    x2: 972.2107,
    y2: 1203.8542
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178170532202530042390000016175667388643969193_)"
    },
    d: "M972.2,1201.915L972.2,1201.915 c-0.212,3.917-3.414,7.006-7.337,7.078l-257.267,4.689c-4.186,0.076-7.62-3.296-7.62-7.483v-0.611 c0-4.087,3.279-7.418,7.365-7.482l257.267-4.078C968.947,1193.958,972.434,1197.582,972.2,1201.915z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102524786199020559110000007917531427475907004_",
    gradientUnits: "userSpaceOnUse",
    x1: 628.6863,
    y1: 1377.1255,
    x2: 1028.6089,
    y2: 1377.1255
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102524786199020559110000007917531427475907004_)"
    },
    d: "M998.462,1523.415 c-0.089,0-0.177-0.002-0.266-0.002l-347.968-4.175c-5.854-0.071-11.32-2.426-15.394-6.628c-4.073-4.2-6.255-9.739-6.144-15.59 l8.956-244.866c0.108-5.753,2.481-11.187,6.679-15.226c4.198-4.041,9.73-6.174,15.542-6.089l347.363,6.76 c11.999,0.234,21.588,10.187,21.375,22.188c0,0.024-0.001,0.045-0.001,0.069l-8.348,242.21 C1020.048,1513.861,1010.295,1523.415,998.462,1523.415z M659.437,1238.893c-3.571,0-6.944,1.358-9.524,3.842 c-2.646,2.546-4.142,5.971-4.212,9.642l-8.956,244.866c-0.068,3.618,1.308,7.108,3.876,9.758 c2.568,2.648,6.014,4.132,9.705,4.177l347.967,4.175c0.056,0,0.112,0.002,0.168,0.002c7.46,0,13.608-6.022,13.74-13.5 l8.348-242.244c0.116-7.551-5.922-13.809-13.476-13.955l-347.363-6.76C659.619,1238.895,659.527,1238.893,659.437,1238.893z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039123914252943976250000011137589207323271075_",
    gradientUnits: "userSpaceOnUse",
    x1: 637.0784,
    y1: 1282.0992,
    x2: 1024.099,
    y2: 1282.0992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039123914252943976250000011137589207323271075_)"
    },
    d: "M1020.07,1286.129H641.108 c-2.225,0-4.029-1.804-4.029-4.029s1.804-4.029,4.029-4.029h378.962c2.225,0,4.029,1.804,4.029,4.029 S1022.295,1286.129,1020.07,1286.129z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013902761109596898860000015082812311442393242_",
    gradientUnits: "userSpaceOnUse",
    x1: 1251.0988,
    y1: 795.2911,
    x2: 213.2569,
    y2: 1513.4928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000013902761109596898860000015082812311442393242_)"
    },
    cx: 944.342,
    cy: 1007.571,
    r: 153.424
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000144319548366343024330000000873388602549337521_",
    gradientUnits: "userSpaceOnUse",
    x1: 800.8959,
    y1: 991.1612,
    x2: 806.9838,
    y2: 991.1612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000144319548366343024330000000873388602549337521_)"
    },
    d: "M802.912,1002.07 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.316-6.05,1.019-12.121,2.088-18.043 c0.197-1.094,1.237-1.814,2.34-1.625c1.095,0.199,1.822,1.245,1.624,2.341c-1.039,5.757-1.721,11.657-2.029,17.536 C804.866,1001.235,803.977,1002.07,802.912,1002.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147218335384309313330000004372705015043286968_",
    gradientUnits: "userSpaceOnUse",
    x1: 815.8151,
    y1: 904.8911,
    x2: 971.9073,
    y2: 904.8911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147218335384309313330000004372705015043286968_)"
    },
    d: "M817.828,945.853 c-0.305,0-0.615-0.069-0.906-0.216c-0.994-0.502-1.392-1.714-0.89-2.705c24.597-48.731,73.763-79.003,128.31-79.003 c8.701,0,17.418,0.785,25.912,2.331c1.095,0.199,1.82,1.247,1.621,2.341c-0.199,1.096-1.244,1.832-2.343,1.621 c-8.255-1.503-16.731-2.264-25.19-2.264c-53.017,0-100.805,29.424-124.713,76.787 C819.274,945.448,818.565,945.853,817.828,945.853z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -437.2537 966.2044)",
    style: {
      fill: "#91B3FA"
    },
    cx: 947.685,
    cy: 1010.914,
    rx: 129.855,
    ry: 129.855
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.59,
      fill: "#FFFFFF"
    },
    d: "M987.442,961.846c0,21.988-17.825,45.725-39.812,45.725 c-21.988,0-39.812-23.737-39.812-45.725c0-21.988,17.824-37.587,39.812-37.587C969.617,924.26,987.442,939.859,987.442,961.846z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160874456052254075270000014772444607927674240_",
    gradientUnits: "userSpaceOnUse",
    x1: 870.663,
    y1: 1056.2457,
    x2: 1024.1735,
    y2: 1056.2457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160874456052254075270000014772444607927674240_)"
    },
    d: "M898.223,1092.225h97.188 c10.231,0,19.289-6.612,22.406-16.356l5.23-16.346c3.829-11.968-2.396-24.926-14.198-29.241 c-39.552-14.461-80.45-12.606-122.346,1.334c-11.737,3.905-18.25,16.46-15.012,28.398l4.027,14.845 C878.299,1085.11,887.602,1092.225,898.223,1092.225z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096762273825031769410000016894095248676749204_",
    gradientUnits: "userSpaceOnUse",
    x1: 1951.5431,
    y1: 795.2911,
    x2: 913.7013,
    y2: 1513.4928
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000096762273825031769410000016894095248676749204_)"
    },
    cx: 1644.786,
    cy: 1007.571,
    r: 153.424
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134945685945538241200000010171910547054806696_",
    gradientUnits: "userSpaceOnUse",
    x1: 1501.3408,
    y1: 991.1612,
    x2: 1507.4277,
    y2: 991.1612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134945685945538241200000010171910547054806696_)"
    },
    d: "M1503.357,1002.07 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.316-6.048,1.018-12.117,2.087-18.043 c0.197-1.094,1.243-1.814,2.34-1.625c1.095,0.199,1.822,1.245,1.624,2.341c-1.038,5.759-1.72,11.659-2.028,17.536 C1505.311,1001.235,1504.422,1002.07,1503.357,1002.07z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008135527162431073980000012959375365663846284_",
    gradientUnits: "userSpaceOnUse",
    x1: 1516.26,
    y1: 904.8911,
    x2: 1672.3521,
    y2: 904.8911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008135527162431073980000012959375365663846284_)"
    },
    d: "M1518.273,945.853 c-0.305,0-0.615-0.069-0.906-0.216c-0.993-0.502-1.392-1.714-0.89-2.705c24.597-48.731,73.763-79.003,128.31-79.003 c8.701,0,17.418,0.785,25.912,2.331c1.095,0.199,1.82,1.247,1.621,2.341c-0.199,1.096-1.24,1.832-2.343,1.621 c-8.255-1.503-16.731-2.264-25.189-2.264c-53.018,0-100.805,29.424-124.713,76.787 C1519.719,945.448,1519.01,945.853,1518.273,945.853z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -232.0983 1461.4934)",
    style: {
      fill: "#91B3FA"
    },
    cx: 1648.129,
    cy: 1010.914,
    rx: 129.855,
    ry: 129.855
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.59,
      fill: "#FFFFFF"
    },
    d: "M1687.886,961.846c0,21.988-17.824,45.725-39.812,45.725 c-21.988,0-39.812-23.737-39.812-45.725c0-21.988,17.824-37.587,39.812-37.587 C1670.062,924.26,1687.886,939.859,1687.886,961.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.59,
      fill: "#FFFFFF"
    },
    d: "M1598.667,1092.225h97.188c10.231,0,19.288-6.612,22.406-16.356l5.23-16.346 c3.829-11.968-2.396-24.926-14.198-29.241c-39.552-14.461-80.45-12.606-122.346,1.334c-11.737,3.905-18.25,16.46-15.011,28.398 l4.027,14.845C1578.744,1085.11,1588.047,1092.225,1598.667,1092.225z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064337544980209369850000011921607693516931765_",
    gradientUnits: "userSpaceOnUse",
    x1: 1251.0988,
    y1: 414.4862,
    x2: 213.2569,
    y2: 1132.6879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000064337544980209369850000011921607693516931765_)"
    },
    cx: 944.342,
    cy: 626.766,
    r: 153.424
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013906562524350192560000011280301675795642031_",
    gradientUnits: "userSpaceOnUse",
    x1: 800.8959,
    y1: 610.3545,
    x2: 806.9838,
    y2: 610.3545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013906562524350192560000011280301675795642031_)"
    },
    d: "M802.912,621.266 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.316-6.05,1.019-12.119,2.088-18.045 c0.197-1.094,1.237-1.83,2.34-1.625c1.095,0.199,1.822,1.245,1.624,2.341c-1.039,5.759-1.721,11.659-2.029,17.537 C804.866,620.432,803.977,621.266,802.912,621.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000025402786984294661640000014911795769088188305_",
    gradientUnits: "userSpaceOnUse",
    x1: 815.8151,
    y1: 524.0854,
    x2: 971.9075,
    y2: 524.0854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000025402786984294661640000014911795769088188305_)"
    },
    d: "M817.828,565.048 c-0.305,0-0.615-0.069-0.906-0.216c-0.994-0.502-1.392-1.714-0.89-2.705c24.597-48.73,73.763-79.003,128.31-79.003 c8.705,0,17.422,0.785,25.912,2.333c1.095,0.199,1.821,1.247,1.621,2.343c-0.199,1.094-1.252,1.834-2.343,1.619 c-8.252-1.503-16.727-2.266-25.19-2.266c-53.017,0-100.805,29.424-124.713,76.788 C819.274,564.642,818.565,565.048,817.828,565.048z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -167.9838 854.6692)",
    style: {
      fill: "#91B3FA"
    },
    cx: 947.685,
    cy: 630.109,
    rx: 129.854,
    ry: 129.855
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009556322842533153750000008537297881344262312_",
    gradientUnits: "userSpaceOnUse",
    x1: 907.818,
    y1: 585.1104,
    x2: 987.4421,
    y2: 585.1104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009556322842533153750000008537297881344262312_)"
    },
    d: "M987.442,581.041 c0,21.988-17.825,45.725-39.812,45.725c-21.988,0-39.812-23.737-39.812-45.725c0-21.988,17.824-37.587,39.812-37.587 C969.617,543.455,987.442,559.054,987.442,581.041z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116929768642138407680000013213106021177570465_",
    gradientUnits: "userSpaceOnUse",
    x1: 870.663,
    y1: 675.4408,
    x2: 1024.1735,
    y2: 675.4408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116929768642138407680000013213106021177570465_)"
    },
    d: "M898.223,711.421h97.188 c10.231,0,19.289-6.612,22.406-16.356l5.23-16.346c3.829-11.968-2.396-24.926-14.198-29.241 c-39.552-14.462-80.45-12.606-122.346,1.334c-11.737,3.905-18.25,16.46-15.012,28.398l4.027,14.845 C878.299,704.305,887.602,711.421,898.223,711.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141432510799314379160000003668268607903276695_",
    gradientUnits: "userSpaceOnUse",
    x1: 1951.5431,
    y1: 414.4862,
    x2: 913.7014,
    y2: 1132.6877
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000141432510799314379160000003668268607903276695_)"
    },
    cx: 1644.786,
    cy: 626.766,
    r: 153.424
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022558405956479894410000008753699709522161850_",
    gradientUnits: "userSpaceOnUse",
    x1: 1501.3408,
    y1: 610.3545,
    x2: 1507.4277,
    y2: 610.3545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022558405956479894410000008753699709522161850_)"
    },
    d: "M1503.357,621.266 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.316-6.046,1.018-12.117,2.086-18.045 c0.198-1.094,1.244-1.83,2.34-1.625c1.096,0.199,1.823,1.245,1.625,2.341c-1.038,5.761-1.72,11.661-2.028,17.537 C1505.311,620.432,1504.422,621.266,1503.357,621.266z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164485267597414709490000009975302325114503303_",
    gradientUnits: "userSpaceOnUse",
    x1: 1516.26,
    y1: 524.0854,
    x2: 1672.3523,
    y2: 524.0854
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000164485267597414709490000009975302325114503303_)"
    },
    d: "M1518.273,565.048 c-0.305,0-0.615-0.069-0.906-0.216c-0.993-0.502-1.392-1.714-0.89-2.705c24.597-48.73,73.763-79.003,128.31-79.003 c8.705,0,17.422,0.785,25.912,2.333c1.095,0.199,1.821,1.247,1.621,2.343c-0.199,1.094-1.25,1.834-2.343,1.619 c-8.252-1.503-16.727-2.266-25.189-2.266c-53.018,0-100.805,29.424-124.713,76.788 C1519.719,564.642,1519.01,565.048,1518.273,565.048z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 37.1716 1349.9581)",
    style: {
      fill: "#91B3FA"
    },
    cx: 1648.129,
    cy: 630.109,
    rx: 129.854,
    ry: 129.855
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161631502596466028590000014892444102458117813_",
    gradientUnits: "userSpaceOnUse",
    x1: 1608.2623,
    y1: 585.1104,
    x2: 1687.8864,
    y2: 585.1104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161631502596466028590000014892444102458117813_)"
    },
    d: "M1687.886,581.041 c0,21.988-17.824,45.725-39.812,45.725c-21.988,0-39.812-23.737-39.812-45.725c0-21.988,17.824-37.587,39.812-37.587 C1670.062,543.455,1687.886,559.054,1687.886,581.041z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049941625781971259600000000620213503427077304_",
    gradientUnits: "userSpaceOnUse",
    x1: 1571.1073,
    y1: 675.4408,
    x2: 1724.6178,
    y2: 675.4408
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049941625781971259600000000620213503427077304_)"
    },
    d: "M1598.667,711.421h97.188 c10.231,0,19.288-6.612,22.406-16.356l5.23-16.346c3.829-11.968-2.396-24.926-14.198-29.241 c-39.552-14.462-80.45-12.606-122.346,1.334c-11.737,3.905-18.25,16.46-15.011,28.398l4.027,14.845 C1578.744,704.305,1588.047,711.421,1598.667,711.421z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058588759549177773970000004763927226962151088_",
    gradientUnits: "userSpaceOnUse",
    x1: 1592.4421,
    y1: 1012.3302,
    x2: 554.6003,
    y2: 1730.5319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000058588759549177773970000004763927226962151088_)"
    },
    cx: 1285.686,
    cy: 1224.61,
    r: 153.424
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000161608325700243467360000011269093761758492335_",
    gradientUnits: "userSpaceOnUse",
    x1: 1142.2395,
    y1: 1208.1986,
    x2: 1148.3264,
    y2: 1208.1986
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000161608325700243467360000011269093761758492335_)"
    },
    d: "M1144.256,1219.109 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.316-6.048,1.018-12.117,2.087-18.043 c0.198-1.094,1.239-1.83,2.34-1.625c1.095,0.199,1.822,1.245,1.624,2.341c-1.038,5.758-1.72,11.659-2.028,17.535 C1146.209,1218.275,1145.32,1219.109,1144.256,1219.109z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000076600548297263546080000000945068049556944011_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.1587,
    y1: 1121.9305,
    x2: 1313.2507,
    y2: 1121.9305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000076600548297263546080000000945068049556944011_)"
    },
    d: "M1159.172,1162.893 c-0.305,0-0.615-0.069-0.906-0.216c-0.994-0.502-1.392-1.714-0.89-2.705c24.596-48.73,73.762-79.003,128.31-79.003 c8.701,0,17.418,0.785,25.912,2.331c1.095,0.199,1.82,1.247,1.621,2.341c-0.199,1.096-1.241,1.834-2.343,1.621 c-8.255-1.503-16.731-2.264-25.189-2.264c-53.019,0-100.806,29.424-124.713,76.788 C1160.618,1162.487,1159.908,1162.893,1159.172,1162.893z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -490.7463 1271.1399)",
    style: {
      fill: "#91B3FA"
    },
    cx: 1289.028,
    cy: 1227.953,
    rx: 129.855,
    ry: 129.855
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163784450512060666910000017208705517117048719_",
    gradientUnits: "userSpaceOnUse",
    x1: 1249.1611,
    y1: 1182.9543,
    x2: 1328.7854,
    y2: 1182.9543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163784450512060666910000017208705517117048719_)"
    },
    d: "M1328.785,1178.885 c0,21.988-17.824,45.725-39.812,45.725c-21.988,0-39.812-23.737-39.812-45.725c0-21.987,17.825-37.587,39.812-37.587 C1310.961,1141.299,1328.785,1156.898,1328.785,1178.885z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088097800117931228920000011490660415435585706_",
    gradientUnits: "userSpaceOnUse",
    x1: 1212.0063,
    y1: 1273.2848,
    x2: 1365.5168,
    y2: 1273.2848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088097800117931228920000011490660415435585706_)"
    },
    d: "M1239.566,1309.265h97.188 c10.231,0,19.288-6.612,22.406-16.356l5.23-16.346c3.829-11.968-2.396-24.926-14.198-29.241 c-39.552-14.462-80.45-12.606-122.346,1.334c-11.737,3.905-18.25,16.46-15.012,28.398l4.027,14.845 C1219.643,1302.149,1228.946,1309.265,1239.566,1309.265z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000115512453110711492570000000795910095290324367_",
    gradientUnits: "userSpaceOnUse",
    x1: 1592.4421,
    y1: 197.447,
    x2: 554.6003,
    y2: 915.6487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000115512453110711492570000000795910095290324367_)"
    },
    cx: 1285.686,
    cy: 409.727,
    r: 153.424
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120521151178790692410000012987594039332963979_",
    gradientUnits: "userSpaceOnUse",
    x1: 1142.2395,
    y1: 393.3169,
    x2: 1148.3264,
    y2: 393.3169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000120521151178790692410000012987594039332963979_)"
    },
    d: "M1144.256,404.227 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.316-6.046,1.018-12.117,2.086-18.045 c0.199-1.094,1.249-1.816,2.34-1.625c1.096,0.199,1.823,1.245,1.625,2.341c-1.038,5.76-1.72,11.661-2.028,17.537 C1146.209,403.392,1145.32,404.227,1144.256,404.227z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000082328660096536351190000015321295658775232687_",
    gradientUnits: "userSpaceOnUse",
    x1: 1157.1587,
    y1: 307.047,
    x2: 1313.2511,
    y2: 307.047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000082328660096536351190000015321295658775232687_)"
    },
    d: "M1159.172,348.008 c-0.305,0-0.615-0.069-0.906-0.216c-0.994-0.502-1.392-1.714-0.89-2.705c24.596-48.73,73.762-79.001,128.31-79.001 c8.712,0,17.429,0.785,25.912,2.331c1.095,0.199,1.821,1.247,1.621,2.343c-0.199,1.096-1.251,1.838-2.343,1.619 c-8.245-1.503-16.72-2.264-25.189-2.264c-53.019,0-100.806,29.422-124.713,76.786 C1160.618,347.603,1159.908,348.008,1159.172,348.008z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 85.4631 1032.4661)",
    style: {
      fill: "#91B3FA"
    },
    cx: 1289.028,
    cy: 413.07,
    rx: 129.855,
    ry: 129.855
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041270682414206100340000008912389761831281309_",
    gradientUnits: "userSpaceOnUse",
    x1: 1249.1611,
    y1: 368.0712,
    x2: 1328.7854,
    y2: 368.0712
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000041270682414206100340000008912389761831281309_)"
    },
    d: "M1328.785,364.002 c0,21.988-17.824,45.725-39.812,45.725c-21.988,0-39.812-23.737-39.812-45.725c0-21.988,17.825-37.587,39.812-37.587 C1310.961,326.415,1328.785,342.015,1328.785,364.002z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062184035010213845910000012332995652582970256_",
    gradientUnits: "userSpaceOnUse",
    x1: 1212.0063,
    y1: 458.4016,
    x2: 1365.5168,
    y2: 458.4016
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062184035010213845910000012332995652582970256_)"
    },
    d: "M1239.566,494.381h97.188 c10.231,0,19.288-6.612,22.406-16.356l5.23-16.346c3.829-11.968-2.396-24.926-14.198-29.241 c-39.552-14.461-80.45-12.606-122.346,1.334c-11.737,3.905-18.25,16.46-15.012,28.398l4.027,14.845 C1219.643,487.266,1228.946,494.381,1239.566,494.381z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000001634535309600607010000015259169320529289879_",
    gradientUnits: "userSpaceOnUse",
    x1: 945.6222,
    y1: 1078.8658,
    x2: 331.3537,
    y2: 1730.5886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000001634535309600607010000015259169320529289879_)"
    },
    d: "M309.252,1388.308l4.019,157.483 c0.312,12.233,15.467,22.042,34.053,22.042h469.576c18.81,0,34.058-10.037,34.058-22.419v-147.393 c0-12.099-14.585-22.015-32.956-22.407l-473.595-10.09C324.95,1365.11,308.925,1375.496,309.252,1388.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M348.122,1403.653l10.189,144.819c0.391,5.561,7.432,9.909,15.889,9.811 l427.594-4.956c8.524-0.099,15.356-4.676,15.356-10.287v-125.594c0-5.485-6.536-10.005-14.858-10.276l-437.784-14.268 C355.298,1392.6,347.695,1397.588,348.122,1403.653z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080912010046133985330000006540785054037061760_",
    gradientUnits: "userSpaceOnUse",
    x1: 593.3527,
    y1: 1054.8188,
    x2: 565.3536,
    y2: 1666.8115
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080912010046133985330000006540785054037061760_)"
    },
    d: "M382.221,1417.234v10.432 c0,3.677,4.577,6.642,10.164,6.582l368.804-3.961c5.459-0.059,9.838-2.988,9.838-6.582l0,0c0-3.567-4.317-6.486-9.734-6.581 l-368.804-6.471C386.863,1410.555,382.221,1413.53,382.221,1417.234z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131328208864872504590000017554955778600449703_",
    gradientUnits: "userSpaceOnUse",
    x1: 591.782,
    y1: 1054.7452,
    x2: 563.7827,
    y2: 1666.7405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131328208864872504590000017554955778600449703_)"
    },
    d: "M387.727,1456.64v9.569 c0,3.725,4.693,6.709,10.349,6.579l351.266-8.054c5.384-0.124,9.653-3.033,9.653-6.579v-2.984c0-3.652-4.517-6.606-10.064-6.583 l-351.265,1.468C392.166,1450.08,387.727,1453.02,387.727,1456.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M774.28,856.537l-5.833-1.591c-1.081-0.295-1.718-1.41-1.423-2.49 c0.295-1.081,1.409-1.718,2.49-1.423l0.009,0.003l5.826,1.616c1.072,0.297,1.7,1.408,1.403,2.48 C776.454,856.204,775.352,856.834,774.28,856.537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M754.85,851.609l-5.904-1.292c-1.118-0.244-1.826-1.349-1.581-2.467 c0.244-1.117,1.349-1.826,2.467-1.581l0.009,0.002l5.898,1.317c1.11,0.248,1.808,1.349,1.56,2.458 C757.052,851.156,755.96,851.857,754.85,851.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M735.203,847.671l-5.96-0.994c-1.153-0.192-1.932-1.283-1.739-2.436 c0.192-1.153,1.283-1.932,2.436-1.739l0.009,0.001l5.956,1.02c1.145,0.197,1.914,1.284,1.718,2.429 C737.426,847.097,736.348,847.868,735.203,847.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M715.387,844.719l-6.002-0.698c-1.185-0.138-2.035-1.21-1.897-2.395 c0.138-1.185,1.211-2.035,2.396-1.897l0.01,0.001l5.999,0.724c1.177,0.143,2.017,1.212,1.875,2.389 C717.625,844.021,716.565,844.861,715.387,844.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M695.45,842.747l-6.03-0.403c-1.215-0.082-2.134-1.133-2.053-2.348 c0.081-1.215,1.132-2.134,2.347-2.053l0.01,0.001l6.028,0.43c1.208,0.087,2.117,1.135,2.03,2.342 C697.696,841.922,696.657,842.832,695.45,842.747z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M675.439,841.748l-6.044-0.11c-1.242-0.023-2.231-1.048-2.208-2.29 c0.023-1.242,1.048-2.231,2.29-2.208l0.01,0.001l6.043,0.137c1.235,0.027,2.213,1.052,2.185,2.286 C677.688,840.798,676.674,841.777,675.439,841.748z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M655.4,841.721l-6.043,0.181c-1.266,0.038-2.324-0.958-2.362-2.224 c-0.038-1.266,0.958-2.323,2.224-2.361l0.01-0.001l6.044-0.155c1.259-0.032,2.306,0.963,2.338,2.221 C657.643,840.642,656.659,841.688,655.4,841.721z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M635.382,842.657l-6.028,0.471c-1.287,0.101-2.413-0.861-2.513-2.148 c-0.101-1.288,0.861-2.413,2.149-2.513l0.01-0.001l6.029-0.445c1.281-0.094,2.395,0.868,2.49,2.147 C637.614,841.449,636.663,842.563,635.382,842.657z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M615.434,844.554l-5.998,0.76c-1.305,0.165-2.498-0.759-2.663-2.065 c-0.165-1.305,0.759-2.498,2.064-2.663l0.01-0.001l6.001-0.734c1.299-0.158,2.48,0.765,2.639,2.065 C617.646,843.215,616.732,844.396,615.434,844.554z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M595.602,847.406l-5.954,1.047c-1.32,0.232-2.578-0.65-2.81-1.97 c-0.232-1.32,0.65-2.578,1.97-2.81l0.01-0.002l5.959-1.02c1.314-0.225,2.561,0.657,2.786,1.971 C597.787,845.935,596.915,847.18,595.602,847.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M575.933,851.206l-5.897,1.333c-1.331,0.301-2.654-0.535-2.955-1.866 c-0.301-1.331,0.534-2.654,1.866-2.955l0.011-0.002l5.902-1.307c1.325-0.293,2.638,0.543,2.931,1.869 C578.085,849.602,577.259,850.913,575.933,851.206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M556.475,855.951l-5.824,1.616c-1.339,0.372-2.725-0.412-3.097-1.751 c-0.372-1.338,0.412-2.725,1.751-3.097l0.011-0.003l5.831-1.591c1.333-0.364,2.709,0.422,3.073,1.755 C558.583,854.214,557.808,855.587,556.475,855.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M537.276,861.635l-5.737,1.9c-1.342,0.445-2.79-0.283-3.235-1.626 c-0.444-1.342,0.283-2.79,1.626-3.234l0.011-0.003l5.746-1.875c1.337-0.436,2.775,0.294,3.211,1.632 C539.333,859.765,538.614,861.199,537.276,861.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M518.387,868.252l-5.636,2.181c-1.341,0.518-2.85-0.149-3.368-1.489 c-0.519-1.342,0.148-2.85,1.489-3.368l0.011-0.005l5.646-2.155c1.337-0.511,2.834,0.159,3.345,1.496 C520.383,866.248,519.724,867.742,518.387,868.252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M499.852,875.797l-5.52,2.459c-1.336,0.596-2.902-0.005-3.497-1.341 c-0.595-1.336,0.005-2.902,1.341-3.497l0.011-0.005l5.53-2.436c1.332-0.586,2.887,0.018,3.474,1.35 C501.778,873.66,501.184,875.211,499.852,875.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M481.724,884.263L476.335,887c-1.326,0.674-2.947,0.145-3.621-1.181 c-0.673-1.326-0.145-2.947,1.181-3.621l0.011-0.005l5.401-2.713c1.322-0.665,2.933-0.131,3.597,1.191 C483.569,881.994,483.046,883.599,481.724,884.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M464.048,893.643l-5.242,3.009c-1.311,0.753-2.984,0.3-3.737-1.011 c-0.753-1.311-0.3-2.984,1.011-3.736l0.01-0.006l5.256-2.986c1.308-0.743,2.971-0.285,3.714,1.023 C465.804,891.243,465.356,892.9,464.048,893.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M446.876,903.906l-5.083,3.268c-1.292,0.831-3.013,0.458-3.844-0.835 c-0.831-1.292-0.457-3.013,0.835-3.843l0.01-0.007l5.097-3.246c1.29-0.821,3.001-0.442,3.822,0.848 C448.535,901.38,448.165,903.085,446.876,903.906z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M430.243,915.015l-4.914,3.517c-1.269,0.908-3.034,0.616-3.943-0.653 c-0.908-1.27-0.616-3.035,0.654-3.943l0.01-0.008l4.929-3.495c1.267-0.898,3.023-0.599,3.921,0.668 C431.799,912.368,431.51,914.117,430.243,915.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M414.181,926.934l-4.735,3.754c-1.242,0.985-3.048,0.776-4.032-0.466 c-0.985-1.242-0.776-3.047,0.466-4.032l0.01-0.008l4.752-3.733c1.241-0.975,3.037-0.759,4.012,0.481 C415.627,924.171,415.421,925.959,414.181,926.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M398.72,939.625l-4.548,3.98c-1.211,1.06-3.053,0.939-4.113-0.273 c-1.06-1.211-0.938-3.052,0.274-4.113l0.01-0.008l4.566-3.961c1.21-1.05,3.043-0.92,4.093,0.29 C400.051,936.75,399.931,938.574,398.72,939.625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M383.891,953.053l-4.351,4.196c-1.176,1.134-3.049,1.101-4.184-0.076 c-1.134-1.177-1.1-3.049,0.076-4.184l0.009-0.009l4.37-4.178c1.176-1.124,3.041-1.082,4.165,0.093 C385.1,950.073,385.067,951.929,383.891,953.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M369.726,967.182l-4.145,4.401c-1.137,1.208-3.038,1.265-4.245,0.128 c-1.208-1.137-1.265-3.038-0.128-4.246l0.009-0.009l4.164-4.383c1.137-1.197,3.03-1.246,4.227-0.108 C370.806,964.102,370.864,965.985,369.726,967.182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M356.257,981.975l-3.929,4.596c-1.094,1.279-3.018,1.429-4.297,0.335 c-1.279-1.094-1.43-3.018-0.336-4.297l0.009-0.01l3.949-4.578c1.095-1.269,3.011-1.411,4.28-0.316 C357.202,978.8,357.352,980.706,356.257,981.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M343.514,997.395l-3.704,4.779c-1.046,1.35-2.988,1.595-4.338,0.549 c-1.35-1.046-1.596-2.987-0.55-4.337l0.008-0.011l3.725-4.762c1.047-1.34,2.982-1.576,4.322-0.528 C344.317,994.131,344.561,996.056,343.514,997.395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M331.528,1013.407l-3.469,4.951c-0.994,1.419-2.95,1.763-4.368,0.768 c-1.419-0.994-1.763-2.949-0.769-4.368l0.008-0.012l3.491-4.935c0.996-1.409,2.945-1.742,4.353-0.747 C332.182,1010.061,332.524,1011.999,331.528,1013.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M320.331,1029.974l-3.226,5.112c-0.937,1.485-2.901,1.93-4.387,0.993 c-1.486-0.936-1.93-2.901-0.993-4.386l0.008-0.012l3.248-5.099c0.94-1.475,2.898-1.909,4.373-0.97 C320.829,1026.553,321.271,1028.499,320.331,1029.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.952,1047.06l-2.972,5.263c-0.876,1.551-2.843,2.098-4.394,1.223s-2.098-2.843-1.222-4.394 l0.007-0.012l2.995-5.25c0.879-1.54,2.84-2.077,4.381-1.198C310.288,1043.571,310.831,1045.52,309.952,1047.06z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M300.426,1064.628l-2.709,5.401c-0.809,1.614-2.774,2.266-4.388,1.457 c-1.614-0.81-2.266-2.774-1.457-4.388l0.006-0.013l2.733-5.39c0.813-1.603,2.773-2.245,4.376-1.431 C300.591,1061.077,301.239,1063.024,300.426,1064.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M291.78,1082.64l-2.436,5.53c-0.738,1.674-2.694,2.434-4.368,1.696 c-1.675-0.738-2.434-2.693-1.696-4.369l0.006-0.013l2.461-5.52c0.742-1.664,2.693-2.413,4.358-1.67 C291.769,1079.036,292.523,1080.975,291.78,1082.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M284.038,1101.052l-2.16,5.644c-0.659,1.723-2.591,2.585-4.314,1.925 c-1.723-0.659-2.585-2.59-1.926-4.313l0.003-0.008l2.174-5.639c0.662-1.718,2.591-2.573,4.309-1.911 C283.842,1097.413,284.701,1099.335,284.038,1101.052z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M277.235,1119.833l-1.859,5.751c-0.572,1.769-2.469,2.739-4.237,2.167 c-1.769-0.573-2.739-2.469-2.167-4.238l0.003-0.008l1.874-5.747c0.575-1.763,2.47-2.726,4.233-2.151 C276.844,1116.183,277.81,1118.069,277.235,1119.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M271.468,1138.936l-1.532,5.846c-0.475,1.811-2.328,2.895-4.139,2.42 c-1.811-0.474-2.895-2.327-2.42-4.138l0.002-0.009l1.547-5.842c0.478-1.806,2.33-2.882,4.136-2.404 C270.867,1135.286,271.946,1137.13,271.468,1138.936z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M266.803,1158.327l-1.187,5.926c-0.37,1.85-2.17,3.048-4.019,2.679 c-1.85-0.371-3.048-2.17-2.678-4.019l0.002-0.009l1.202-5.923c0.374-1.844,2.173-3.037,4.017-2.662 C265.983,1154.693,267.177,1156.483,266.803,1158.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M263.304,1177.951l-0.819,5.988c-0.257,1.883-1.992,3.2-3.874,2.942 c-1.883-0.257-3.2-1.992-2.943-3.874l0.001-0.009l0.834-5.987c0.261-1.877,1.996-3.187,3.873-2.926 C262.254,1174.347,263.566,1176.073,263.304,1177.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M261.051,1197.74l-0.424,6.029c-0.134,1.909-1.79,3.349-3.699,3.214 c-1.909-0.134-3.348-1.79-3.214-3.7l0.001-0.009l0.439-6.027c0.139-1.905,1.795-3.337,3.7-3.198 C259.757,1194.188,261.189,1195.836,261.051,1197.74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.134,1217.619l0.002,6.044c0.001,1.927-1.561,3.49-3.489,3.491 c-1.927,0.001-3.491-1.561-3.491-3.489v-0.009l0.013-6.044c0.004-1.923,1.566-3.479,3.49-3.475 C258.583,1214.141,260.139,1215.695,260.134,1217.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.658,1237.489l0.461,6.026c0.148,1.936-1.301,3.625-3.236,3.774 c-1.936,0.148-3.625-1.301-3.773-3.236l-0.001-0.009l-0.446-6.027c-0.143-1.932,1.307-3.614,3.239-3.758 C258.833,1234.115,260.515,1235.557,260.658,1237.489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M262.728,1257.234l0.954,5.967c0.309,1.93-1.006,3.746-2.937,4.054 c-1.931,0.309-3.746-1.005-4.055-2.936l-0.001-0.009l-0.939-5.969c-0.303-1.927,1.013-3.736,2.94-4.039 C260.617,1253.999,262.424,1255.307,262.728,1257.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M266.448,1276.71l1.477,5.86c0.481,1.909-0.676,3.847-2.585,4.328 c-1.909,0.482-3.847-0.676-4.328-2.585l-0.002-0.009l-1.463-5.864c-0.476-1.906,0.684-3.837,2.59-4.313 C264.043,1273.651,265.972,1274.803,266.448,1276.71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M271.908,1295.746l2.023,5.695c0.664,1.868-0.312,3.921-2.181,4.585 c-1.868,0.663-3.921-0.313-4.585-2.181l-0.003-0.009l-2.009-5.699c-0.658-1.866,0.321-3.912,2.187-4.57 C269.207,1292.908,271.25,1293.88,271.908,1295.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M279.165,1314.149l2.578,5.462c0.852,1.805,0.079,3.959-1.726,4.812 c-1.805,0.852-3.96,0.079-4.812-1.726l-0.004-0.008l-2.564-5.468c-0.846-1.804-0.069-3.953,1.734-4.799 C276.175,1311.577,278.319,1312.345,279.165,1314.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.227,1331.722l3.113,5.18c1.035,1.723,0.478,3.959-1.245,4.995 c-1.723,1.035-3.959,0.477-4.994-1.245l-0.005-0.008l-3.1-5.188c-1.029-1.722-0.467-3.953,1.255-4.981 C284.972,1329.446,287.198,1330,288.227,1331.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M298.983,1348.336l3.59,4.86c1.202,1.629,0.857,3.923-0.771,5.125 c-1.628,1.203-3.923,0.858-5.125-0.77l-0.006-0.008l-3.578-4.869c-1.196-1.628-0.846-3.917,0.782-5.112 C295.504,1346.365,297.787,1346.709,298.983,1348.336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M311.246,1363.898l4.004,4.525c1.35,1.526,1.208,3.857-0.318,5.208 c-1.526,1.351-3.858,1.208-5.208-0.318l-0.006-0.008l-3.993-4.535c-1.344-1.526-1.196-3.853,0.33-5.197 C307.581,1362.229,309.902,1362.371,311.246,1363.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M324.813,1378.373l4.355,4.189c1.479,1.422,1.524,3.774,0.102,5.252 c-1.422,1.479-3.774,1.524-5.252,0.102l-0.007-0.007l-4.345-4.199c-1.472-1.423-1.512-3.771-0.089-5.242 C321,1376.996,323.341,1376.95,324.813,1378.373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M339.485,1391.774l4.647,3.863c1.588,1.32,1.805,3.678,0.485,5.267 c-1.32,1.588-3.678,1.805-5.266,0.484l-0.008-0.006l-4.637-3.875c-1.582-1.322-1.792-3.675-0.471-5.257 S337.903,1390.452,339.485,1391.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M355.077,1404.14l4.887,3.556c1.681,1.223,2.052,3.578,0.829,5.258 c-1.223,1.681-3.578,2.053-5.259,0.829l-0.008-0.006l-4.878-3.568c-1.675-1.225-2.039-3.576-0.814-5.25 C351.059,1403.284,353.402,1402.915,355.077,1404.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M371.427,1415.532l5.074,3.265c1.76,1.132,2.269,3.477,1.136,5.237 c-1.133,1.76-3.477,2.268-5.237,1.136l-0.008-0.005l-5.066-3.278c-1.754-1.135-2.255-3.476-1.121-5.23 C367.34,1414.905,369.673,1414.398,371.427,1415.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M388.395,1426.019l5.242,3.008c1.827,1.049,2.458,3.379,1.41,5.207 c-1.048,1.827-3.38,2.458-5.207,1.41l-0.009-0.005l-5.234-3.022c-1.821-1.051-2.445-3.379-1.394-5.2 C384.254,1425.596,386.574,1424.968,388.395,1426.019z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M405.876,1435.68l5.372,2.77c1.885,0.971,2.625,3.286,1.653,5.171 c-0.972,1.885-3.287,2.625-5.172,1.653l-0.009-0.004l-5.365-2.783c-1.879-0.975-2.611-3.288-1.637-5.167 C401.693,1435.443,403.997,1434.705,405.876,1435.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M423.774,1444.588l5.478,2.554c1.934,0.902,2.771,3.201,1.87,5.135 c-0.902,1.934-3.201,2.771-5.135,1.87l-0.009-0.005l-5.472-2.566c-1.928-0.905-2.758-3.202-1.853-5.13 C419.557,1444.517,421.846,1443.683,423.774,1444.588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M442.016,1452.812l5.571,2.362c1.978,0.838,2.901,3.12,2.063,5.099 c-0.838,1.977-3.121,2.901-5.099,2.063l-0.009-0.004l-5.565-2.376c-1.972-0.841-2.888-3.122-2.046-5.094 C437.772,1452.891,440.044,1451.971,442.016,1452.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M460.551,1460.433l5.634,2.194c2.014,0.784,3.012,3.052,2.227,5.067 c-0.784,2.015-3.053,3.011-5.067,2.227l-0.009-0.003l-5.628-2.208c-2.009-0.788-2.998-3.054-2.211-5.063 C456.285,1460.639,458.543,1459.645,460.551,1460.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M479.297,1467.523l5.691,2.035c2.048,0.733,3.115,2.988,2.382,5.036 c-0.733,2.048-2.987,3.114-5.035,2.382l-0.009-0.004l-5.686-2.05c-2.043-0.736-3.102-2.988-2.365-5.032 C475.011,1467.848,477.254,1466.786,479.297,1467.523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M498.228,1474.089l5.744,1.878c2.081,0.68,3.216,2.919,2.536,4.999 c-0.68,2.08-2.919,3.216-4.999,2.536l-0.009-0.003l-5.739-1.893c-2.075-0.684-3.203-2.921-2.519-4.996 C493.925,1474.535,496.153,1473.404,498.228,1474.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M517.329,1480.132l5.793,1.72c2.112,0.627,3.315,2.848,2.688,4.959 c-0.627,2.112-2.847,3.316-4.959,2.688l-0.009-0.003l-5.788-1.734c-2.106-0.632-3.302-2.85-2.671-4.957 C513.013,1480.699,515.223,1479.501,517.329,1480.132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M536.587,1485.652l5.837,1.562c2.141,0.573,3.413,2.774,2.839,4.916 c-0.573,2.141-2.774,3.412-4.915,2.839l-0.01-0.002l-5.833-1.577c-2.136-0.577-3.399-2.777-2.822-4.914 C532.261,1486.341,534.451,1485.075,536.587,1485.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M555.987,1490.649l5.877,1.405c2.169,0.518,3.508,2.697,2.989,4.866 c-0.518,2.169-2.697,3.508-4.867,2.99l-0.01-0.002l-5.874-1.419c-2.164-0.523-3.495-2.701-2.972-4.865 C551.654,1491.459,553.823,1490.126,555.987,1490.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M575.514,1495.123l5.913,1.246c2.196,0.463,3.601,2.619,3.138,4.814 c-0.463,2.197-2.619,3.601-4.815,3.138l-0.01-0.002l-5.91-1.261c-2.191-0.468-3.588-2.623-3.12-4.813 C571.178,1496.055,573.323,1494.655,575.514,1495.123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M595.155,1499.074l5.944,1.088c2.221,0.407,3.692,2.538,3.285,4.759 c-0.407,2.22-2.537,3.692-4.758,3.285l-0.01-0.002l-5.942-1.104c-2.216-0.411-3.679-2.541-3.267-4.757 C590.818,1500.126,592.939,1498.662,595.155,1499.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M614.895,1502.5l5.972,0.932c2.245,0.35,3.781,2.453,3.431,4.698 c-0.35,2.245-2.453,3.78-4.698,3.43l-0.01-0.001l-5.969-0.946c-2.24-0.355-3.768-2.458-3.413-4.698 C610.562,1503.676,612.655,1502.146,614.895,1502.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M634.72,1505.404l5.995,0.773c2.267,0.292,3.867,2.367,3.575,4.633 c-0.292,2.267-2.367,3.868-4.634,3.576l-0.01-0.002l-5.993-0.788c-2.262-0.297-3.854-2.372-3.557-4.633 C630.393,1506.7,632.458,1505.107,634.72,1505.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M654.616,1507.785l6.013,0.615c2.287,0.234,3.952,2.278,3.718,4.565 c-0.234,2.287-2.278,3.952-4.565,3.718l-0.01-0.002l-6.012-0.63c-2.283-0.239-3.939-2.284-3.7-4.566 C650.299,1509.202,652.333,1507.544,654.616,1507.785z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M674.569,1509.641l6.028,0.456c2.307,0.175,4.034,2.187,3.859,4.494 c-0.175,2.307-2.186,4.034-4.493,3.859h-0.01l-6.027-0.472c-2.302-0.181-4.022-2.193-3.841-4.495 C670.265,1511.181,672.267,1509.46,674.569,1509.641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M694.565,1510.973l6.038,0.3c2.324,0.115,4.115,2.092,4,4.416c-0.115,2.324-2.092,4.115-4.417,4 h-0.01l-6.038-0.315c-2.32-0.12-4.102-2.098-3.981-4.419C690.278,1512.635,692.245,1510.853,694.565,1510.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M714.591,1511.793l6.044,0.147c2.331,0.056,4.175,1.992,4.119,4.322 c-0.056,2.331-1.992,4.176-4.323,4.119h-0.003l-6.044-0.151c-2.33-0.059-4.171-1.995-4.113-4.324 C710.329,1513.577,712.261,1511.735,714.591,1511.793z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M734.631,1512.095l6.046-0.012c2.336-0.005,4.234,1.886,4.238,4.222 c0.005,2.336-1.886,4.234-4.222,4.239h-0.003l-6.046,0.007c-2.335,0.002-4.23-1.889-4.233-4.223 C730.409,1513.993,732.296,1512.098,734.631,1512.095z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M754.672,1511.873l6.044-0.17c2.34-0.065,4.29,1.779,4.356,4.118 c0.066,2.34-1.778,4.291-4.118,4.356l-0.003,0.001l-6.044,0.164c-2.339,0.064-4.286-1.78-4.35-4.119 C750.493,1513.884,752.334,1511.937,754.672,1511.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M774.7,1511.126l6.037-0.328c2.342-0.127,4.344,1.668,4.471,4.011 c0.127,2.341-1.668,4.343-4.01,4.471h-0.003l-6.037,0.323c-2.341,0.126-4.34-1.67-4.465-4.011 C770.567,1513.251,772.359,1511.252,774.7,1511.126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M794.701,1509.856l6.026-0.486c2.342-0.189,4.395,1.556,4.583,3.898 c0.189,2.342-1.557,4.395-3.899,4.584h-0.003l-6.026,0.481c-2.341,0.187-4.391-1.559-4.578-3.9 C790.617,1512.092,792.359,1510.043,794.701,1509.856z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M814.659,1508.061l6.011-0.644c2.341-0.251,4.442,1.444,4.693,3.785 c0.251,2.34-1.443,4.442-3.784,4.693h-0.004l-6.011,0.639c-2.34,0.249-4.439-1.446-4.688-3.786 C810.627,1510.409,812.319,1508.31,814.659,1508.061z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M834.561,1505.742l5.991-0.803c2.338-0.314,4.488,1.328,4.801,3.666 c0.313,2.338-1.328,4.488-3.667,4.801h-0.003l-5.992,0.798c-2.337,0.311-4.484-1.331-4.795-3.668 C830.585,1508.2,832.224,1506.053,834.561,1505.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M854.393,1502.898l5.968-0.961c2.334-0.376,4.53,1.212,4.906,3.545 c0.376,2.333-1.211,4.53-3.545,4.906h-0.004l-5.968,0.956c-2.333,0.374-4.526-1.214-4.9-3.546 C850.476,1505.465,852.061,1503.272,854.393,1502.898z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M874.142,1499.53l5.94-1.119c2.327-0.439,4.569,1.093,5.008,3.419 c0.439,2.328-1.093,4.57-3.42,5.008l-0.003,0.001l-5.94,1.115c-2.326,0.437-4.566-1.096-5.002-3.422 C870.287,1502.206,871.815,1499.967,874.142,1499.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M893.791,1495.638l5.907-1.278c2.319-0.502,4.606,0.972,5.107,3.291 c0.501,2.32-0.972,4.606-3.291,5.107l-0.003,0.001l-5.908,1.273c-2.318,0.499-4.602-0.975-5.102-3.294 C890.002,1498.42,891.473,1496.136,893.791,1495.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M913.326,1491.22l5.87-1.436c2.309-0.565,4.639,0.85,5.204,3.159 c0.565,2.31-0.849,4.639-3.159,5.204l-0.003,0.001l-5.871,1.431c-2.308,0.563-4.636-0.853-5.198-3.161 C909.606,1494.109,911.017,1491.783,913.326,1491.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M932.732,1486.278l5.829-1.594c2.297-0.629,4.669,0.725,5.298,3.022 c0.628,2.298-0.725,4.67-3.022,5.298l-0.003,0.001l-5.83,1.589c-2.297,0.627-4.666-0.728-5.292-3.025 C929.085,1489.273,930.435,1486.905,932.732,1486.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M951.997,1480.812l5.783-1.753c2.284-0.692,4.696,0.598,5.388,2.882 c0.692,2.284-0.598,4.696-2.882,5.389l-0.004,0.001l-5.784,1.748c-2.283,0.69-4.693-0.602-5.383-2.885 C948.425,1483.911,949.714,1481.502,951.997,1480.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M971.103,1474.822l5.733-1.91c2.268-0.756,4.72,0.47,5.476,2.739 c0.756,2.268-0.47,4.72-2.738,5.475l-0.003,0.002l-5.734,1.905c-2.268,0.754-4.717-0.473-5.471-2.741 C967.612,1478.024,968.836,1475.575,971.103,1474.822z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M990.038,1468.308l5.678-2.069c2.251-0.819,4.74,0.34,5.56,2.591c0.82,2.251-0.34,4.74-2.591,5.56 l-0.003,0.001l-5.68,2.065c-2.25,0.818-4.737-0.344-5.555-2.594C986.63,1471.611,987.788,1469.125,990.038,1468.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1008.798,1461.265l5.604-2.221c2.23-0.887,4.757,0.201,5.645,2.43 c0.888,2.23-0.2,4.757-2.43,5.645l-0.01,0.004l-5.64,2.23c-2.231,0.881-4.754-0.213-5.636-2.443 c-0.882-2.231,0.212-4.754,2.442-5.636L1008.798,1461.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1027.335,1453.709l5.556-2.382c2.21-0.947,4.77,0.076,5.718,2.285 c0.948,2.21-0.075,4.77-2.285,5.718l-0.003,0.001l-5.558,2.379c-2.21,0.945-4.767-0.08-5.713-2.289 C1024.104,1457.212,1025.125,1454.655,1027.335,1453.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1045.664,1445.638l5.486-2.535c2.187-1.01,4.779-0.057,5.79,2.131 c1.01,2.187,0.057,4.779-2.13,5.789l-0.003,0.002l-5.489,2.53c-2.187,1.008-4.776,0.053-5.785-2.134 C1042.525,1449.235,1043.477,1446.647,1045.664,1445.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1063.761,1437.065l5.414-2.684c2.163-1.072,4.785-0.188,5.857,1.974 c1.072,2.163,0.188,4.785-1.975,5.857l-0.003,0.002l-5.416,2.68c-2.162,1.069-4.782,0.184-5.852-1.978 C1060.716,1440.753,1061.599,1438.136,1063.761,1437.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1081.615,1428.002l5.339-2.83c2.137-1.132,4.787-0.319,5.92,1.818s0.319,4.787-1.818,5.92 l-0.003,0.002l-5.341,2.825c-2.136,1.13-4.785,0.315-5.915-1.822C1078.666,1431.779,1079.479,1429.132,1081.615,1428.002z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1099.216,1418.457l5.26-2.974c2.109-1.192,4.786-0.449,5.978,1.661 c1.192,2.109,0.449,4.786-1.66,5.978l-0.003,0.002l-5.263,2.969c-2.109,1.19-4.783,0.445-5.973-1.664 C1096.365,1422.319,1097.108,1419.647,1099.216,1418.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1116.554,1408.44l5.179-3.113c2.08-1.25,4.781-0.578,6.032,1.502 c1.251,2.081,0.578,4.781-1.502,6.031l-0.003,0.002l-5.181,3.109c-2.08,1.249-4.779,0.574-6.027-1.506 C1113.803,1412.385,1114.474,1409.689,1116.554,1408.44z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1133.618,1397.961l5.094-3.251c2.05-1.308,4.772-0.707,6.081,1.343 c1.308,2.05,0.707,4.773-1.343,6.081l-0.003,0.002l-5.096,3.247c-2.05,1.306-4.771,0.702-6.077-1.347 C1130.969,1401.987,1131.568,1399.268,1133.618,1397.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1150.399,1387.031l5.006-3.386c2.018-1.365,4.761-0.835,6.126,1.183 c1.365,2.018,0.835,4.76-1.183,6.125l-0.003,0.002l-5.009,3.382c-2.018,1.362-4.759,0.83-6.122-1.187 C1147.852,1391.132,1148.38,1388.394,1150.399,1387.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1166.884,1375.658l4.915-3.517c1.985-1.42,4.746-0.963,6.167,1.022s0.963,4.746-1.022,6.167 l-0.003,0.002l-4.918,3.514c-1.985,1.417-4.744,0.958-6.162-1.027C1164.442,1379.834,1164.899,1377.076,1166.884,1375.658z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1183.065,1363.853l4.821-3.646c1.951-1.475,4.728-1.089,6.203,0.862 c1.475,1.951,1.09,4.728-0.861,6.202l-0.003,0.003l-4.824,3.642c-1.951,1.473-4.726,1.085-6.199-0.866 C1180.729,1368.099,1181.114,1365.326,1183.065,1363.853z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1198.931,1351.624l4.724-3.77c1.915-1.529,4.706-1.216,6.235,0.698 c1.529,1.915,1.216,4.707-0.699,6.236l-0.003,0.002l-4.727,3.767c-1.915,1.527-4.705,1.211-6.231-0.704 C1196.704,1355.939,1197.016,1353.151,1198.931,1351.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1214.472,1338.983l4.624-3.893c1.878-1.582,4.682-1.341,6.263,0.536 c1.581,1.878,1.341,4.682-0.536,6.263l-0.003,0.002l-4.627,3.891c-1.878,1.579-4.68,1.337-6.259-0.541 C1212.354,1343.362,1212.594,1340.563,1214.472,1338.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1229.677,1325.938l4.521-4.015c1.839-1.633,4.653-1.466,6.286,0.373 c1.633,1.84,1.466,4.654-0.373,6.287l-0.003,0.002l-4.524,4.01c-1.839,1.631-4.652,1.462-6.282-0.378 S1227.838,1327.568,1229.677,1325.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1244.538,1312.498l4.414-4.131c1.799-1.684,4.622-1.591,6.306,0.209s1.59,4.622-0.209,6.306 l-0.003,0.003l-4.418,4.128c-1.799,1.681-4.621,1.585-6.302-0.214S1242.738,1314.179,1244.538,1312.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1259.042,1298.675l4.305-4.246c1.757-1.733,4.587-1.714,6.321,0.044 c1.733,1.758,1.714,4.587-0.044,6.32l-0.003,0.003l-4.309,4.242c-1.758,1.73-4.586,1.709-6.317-0.049 C1257.264,1303.231,1257.284,1300.405,1259.042,1298.675z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1273.179,1284.476l4.193-4.356c1.715-1.782,4.549-1.837,6.331-0.122 c1.782,1.716,1.836,4.55,0.121,6.332l-0.003,0.002l-4.196,4.353c-1.715,1.78-4.548,1.832-6.328,0.116 C1271.518,1289.087,1271.464,1286.255,1273.179,1284.476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1286.939,1269.914l4.077-4.465c1.671-1.83,4.508-1.958,6.338-0.287 c1.83,1.67,1.958,4.508,0.288,6.337l-0.003,0.003l-4.08,4.461c-1.671,1.828-4.507,1.954-6.334,0.282 C1285.397,1274.574,1285.268,1271.741,1286.939,1269.914z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1300.312,1254.996l3.958-4.569c1.625-1.876,4.463-2.08,6.339-0.455 c1.876,1.625,2.08,4.463,0.455,6.339l-0.002,0.003l-3.962,4.566c-1.626,1.874-4.463,2.076-6.336,0.45 S1298.686,1256.87,1300.312,1254.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1313.287,1239.735l3.836-4.673c1.578-1.921,4.415-2.201,6.337-0.623 c1.922,1.578,2.201,4.416,0.623,6.337l-0.002,0.003l-3.84,4.669c-1.578,1.92-4.414,2.197-6.334,0.618 C1311.987,1244.488,1311.708,1241.655,1313.287,1239.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1325.854,1224.138l3.711-4.771c1.529-1.967,4.363-2.321,6.33-0.791 c1.967,1.529,2.321,4.363,0.791,6.329l-0.002,0.003l-3.715,4.769c-1.53,1.964-4.363,2.316-6.327,0.785 C1324.678,1228.932,1324.324,1226.102,1325.854,1224.138z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1338.003,1208.217l3.583-4.868c1.479-2.01,4.308-2.441,6.318-0.961 c2.01,1.479,2.44,4.309,0.961,6.318l-0.002,0.003l-3.587,4.865c-1.48,2.008-4.308,2.436-6.315,0.955 C1336.952,1213.049,1336.522,1210.224,1338.003,1208.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1349.723,1191.978l3.451-4.961c1.428-2.053,4.249-2.559,6.302-1.131 c2.052,1.428,2.559,4.25,1.131,6.302l-0.002,0.003l-3.455,4.959c-1.429,2.05-4.249,2.554-6.299,1.125 C1348.8,1196.845,1348.294,1194.028,1349.723,1191.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1361.004,1175.435l3.317-5.051c1.375-2.094,4.187-2.678,6.281-1.302 c2.094,1.375,2.677,4.187,1.302,6.281l-0.002,0.003l-3.321,5.048c-1.376,2.092-4.187,2.673-6.278,1.297 C1360.21,1180.334,1359.628,1177.526,1361.004,1175.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1371.835,1158.597l3.179-5.139c1.32-2.135,4.12-2.794,6.255-1.474 c2.134,1.32,2.794,4.121,1.474,6.254l-0.002,0.003l-3.183,5.137c-1.321,2.132-4.121,2.789-6.252,1.468 C1371.172,1163.524,1370.513,1160.729,1371.835,1158.597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1382.205,1141.474l3.039-5.223c1.264-2.173,4.05-2.91,6.224-1.646 c2.173,1.264,2.91,4.051,1.646,6.224l-0.002,0.003l-3.043,5.222c-1.265,2.17-4.051,2.905-6.221,1.64 C1381.676,1146.427,1380.94,1143.645,1382.205,1141.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1392.105,1124.075l2.895-5.304c1.206-2.21,3.976-3.025,6.187-1.819 c2.211,1.207,3.025,3.977,1.819,6.188l-0.002,0.004l-2.899,5.301c-1.208,2.209-3.977,3.021-6.185,1.813 C1391.711,1129.051,1390.897,1126.284,1392.105,1124.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1401.524,1106.414l2.748-5.383c1.147-2.248,3.899-3.139,6.146-1.992 c2.247,1.147,3.139,3.898,1.992,6.146l-0.002,0.003l-2.752,5.38c-1.148,2.246-3.899,3.135-6.144,1.986 C1401.266,1111.406,1400.375,1108.658,1401.524,1106.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1410.451,1088.496l2.597-5.457c1.086-2.282,3.817-3.252,6.099-2.166 c2.282,1.086,3.252,3.817,2.166,6.099l-0.002,0.004l-2.602,5.455c-1.087,2.28-3.817,3.247-6.098,2.16 C1410.332,1093.504,1409.364,1090.777,1410.451,1088.496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1418.88,1070.337l2.448-5.521c1.026-2.316,3.735-3.359,6.05-2.333s3.359,3.735,2.333,6.05 l-0.002,0.004l-2.453,5.52c-1.028,2.313-3.736,3.354-6.048,2.327C1418.895,1075.354,1417.852,1072.65,1418.88,1070.337z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1426.842,1051.956l2.313-5.575c0.972-2.343,3.66-3.455,6.003-2.483 c2.343,0.973,3.454,3.66,2.482,6.004l-0.002,0.004l-2.318,5.573c-0.974,2.34-3.661,3.449-6.002,2.475 C1426.978,1056.98,1425.868,1054.296,1426.842,1051.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1434.38,1033.389l2.193-5.622c0.924-2.368,3.592-3.538,5.959-2.615 c2.368,0.924,3.538,3.591,2.614,5.959l-0.001,0.004l-2.198,5.62c-0.925,2.365-3.593,3.532-5.958,2.608 C1434.624,1038.418,1433.455,1035.754,1434.38,1033.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1441.54,1014.66l2.088-5.662c0.881-2.388,3.531-3.611,5.92-2.731 c2.389,0.88,3.611,3.531,2.731,5.92l-0.001,0.004l-2.092,5.66c-0.882,2.387-3.532,3.607-5.919,2.725 C1441.879,1019.694,1440.658,1017.047,1441.54,1014.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1448.371,995.796l1.997-5.699c0.844-2.406,3.479-3.674,5.885-2.83 c2.407,0.844,3.674,3.478,2.831,5.885l-0.001,0.004l-2.002,5.697c-0.845,2.405-3.48,3.669-5.885,2.824 C1448.791,1000.832,1447.526,998.201,1448.371,995.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1454.926,976.828l1.932-5.725c0.813-2.41,3.426-3.705,5.837-2.891 c2.41,0.814,3.709,3.415,2.895,5.825l-1.916,5.729c-0.808,2.417-3.423,3.72-5.839,2.912c-2.417-0.808-3.72-3.422-2.912-5.838 L1454.926,976.828z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1461.274,957.764l1.871-5.749c0.783-2.405,3.367-3.719,5.771-2.937 c2.405,0.783,3.724,3.355,2.941,5.761l-1.856,5.754c-0.778,2.411-3.363,3.735-5.774,2.957c-2.411-0.777-3.735-3.362-2.958-5.773 L1461.274,957.764z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1467.441,938.615l1.825-5.767c0.758-2.397,3.317-3.725,5.714-2.967 c2.397,0.758,3.729,3.305,2.97,5.703l-1.81,5.771c-0.754,2.404-3.313,3.741-5.716,2.987c-2.403-0.753-3.741-3.312-2.987-5.716 L1467.441,938.615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1473.472,919.413l1.794-5.779c0.741-2.388,3.277-3.722,5.664-2.982 c2.387,0.741,3.725,3.266,2.984,5.653l-1.779,5.784c-0.736,2.393-3.273,3.737-5.666,3.001c-2.393-0.736-3.737-3.273-3.001-5.666 L1473.472,919.413z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1479.419,900.17l1.775-5.777c0.729-2.376,3.247-3.71,5.622-2.98 c2.375,0.729,3.713,3.235,2.983,5.61l-1.759,5.782c-0.725,2.382-3.243,3.725-5.624,3c-2.381-0.724-3.725-3.242-3-5.624 L1479.419,900.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1485.327,880.911l1.773-5.777c0.724-2.362,3.226-3.689,5.588-2.965 c2.361,0.725,3.692,3.216,2.968,5.577l-1.757,5.783c-0.72,2.368-3.222,3.704-5.59,2.984c-2.368-0.72-3.703-3.223-2.984-5.59 L1485.327,880.911z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1491.251,861.646l1.786-5.774c0.725-2.345,3.215-3.659,5.561-2.933 c2.346,0.725,3.663,3.204,2.937,5.55l-1.771,5.778c-0.721,2.352-3.211,3.674-5.563,2.954c-2.352-0.721-3.674-3.212-2.954-5.564 L1491.251,861.646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1497.239,842.387l1.814-5.764c0.732-2.328,3.214-3.622,5.542-2.889 c2.328,0.732,3.625,3.202,2.893,5.53l-1.799,5.77c-0.728,2.334-3.21,3.637-5.544,2.909c-2.334-0.728-3.637-3.21-2.909-5.544 L1497.239,842.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1503.342,823.154l1.86-5.76c0.745-2.309,3.221-3.576,5.53-2.83 c2.309,0.746,3.579,3.211,2.834,5.519l-1.845,5.765c-0.741,2.315-3.218,3.59-5.532,2.85c-2.315-0.741-3.591-3.218-2.85-5.532 L1503.342,823.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1509.614,803.952l1.917-5.738c0.764-2.287,3.238-3.522,5.525-2.757 c2.287,0.764,3.525,3.227,2.761,5.514l-1.902,5.744c-0.76,2.293-3.234,3.536-5.527,2.776c-2.293-0.759-3.536-3.233-2.777-5.527 L1509.614,803.952z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1516.1,784.813l1.99-5.71c0.788-2.263,3.262-3.459,5.526-2.67 c2.263,0.788,3.462,3.251,2.674,5.515l-1.975,5.715c-0.784,2.269-3.259,3.474-5.529,2.69s-3.473-3.26-2.69-5.529L1516.1,784.813z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1522.852,765.753l2.077-5.677c0.818-2.237,3.295-3.387,5.532-2.568 c2.237,0.818,3.391,3.284,2.572,5.521l-2.062,5.682c-0.814,2.244-3.292,3.403-5.535,2.588c-2.243-0.814-3.402-3.291-2.588-5.535 L1522.852,765.753z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1529.917,746.804l2.178-5.637c0.853-2.207,3.335-3.306,5.543-2.452 c2.208,0.853,3.31,3.324,2.457,5.532l-2.163,5.642c-0.849,2.214-3.332,3.321-5.547,2.472c-2.214-0.849-3.321-3.333-2.472-5.547 L1529.917,746.804z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1537.342,727.988l2.294-5.589c0.893-2.176,3.382-3.216,5.558-2.323 c2.176,0.893,3.22,3.371,2.327,5.548l-2.279,5.594c-0.889,2.183-3.38,3.232-5.562,2.342c-2.183-0.889-3.231-3.38-2.342-5.562 L1537.342,727.988z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1545.177,709.327l2.424-5.534c0.938-2.141,3.434-3.116,5.575-2.178 c2.141,0.937,3.121,3.423,2.183,5.565l-2.41,5.541c-0.934,2.147-3.432,3.131-5.58,2.198c-2.148-0.935-3.132-3.433-2.198-5.581 L1545.177,709.327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1553.473,690.839l2.592-5.46c0.992-2.091,3.492-2.982,5.582-1.989 c2.08,0.988,2.971,3.468,2.002,5.553l-2.549,5.48c-0.981,2.11-3.488,3.025-5.598,2.044c-2.11-0.982-3.026-3.488-2.044-5.598 L1553.473,690.839z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1562.401,672.617l2.782-5.365c1.045-2.016,3.525-2.802,5.54-1.757 c2.005,1.04,2.792,3.502,1.771,5.511l-2.739,5.388c-1.035,2.035-3.523,2.846-5.558,1.811s-2.846-3.523-1.811-5.558 L1562.401,672.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1571.962,654.722l2.97-5.264c1.093-1.938,3.551-2.623,5.489-1.529 c1.928,1.088,2.615,3.528,1.545,5.461l-2.928,5.287c-1.084,1.958-3.551,2.667-5.509,1.583c-1.958-1.085-2.667-3.551-1.582-5.51 L1571.962,654.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1582.152,637.178l3.157-5.155c1.139-1.859,3.57-2.443,5.43-1.304 c1.85,1.133,2.437,3.546,1.321,5.402l-3.115,5.179c-1.131,1.88-3.572,2.487-5.452,1.357c-1.88-1.131-2.487-3.572-1.357-5.453 L1582.152,637.178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1592.969,620.013l3.343-5.035c1.182-1.779,3.583-2.264,5.362-1.082 c1.771,1.176,2.258,3.559,1.099,5.336l-3.303,5.062c-1.175,1.799-3.586,2.307-5.386,1.132c-1.8-1.175-2.307-3.587-1.132-5.387 L1592.969,620.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1604.416,603.259l3.532-4.906c1.222-1.697,3.589-2.083,5.287-0.86 c1.689,1.216,2.078,3.566,0.878,5.262l-3.492,4.933c-1.216,1.718-3.595,2.125-5.313,0.908c-1.718-1.216-2.125-3.595-0.909-5.313 L1604.416,603.259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1616.497,586.954l3.722-4.762c1.26-1.613,3.59-1.9,5.203-0.638 c1.605,1.254,1.895,3.568,0.656,5.179l-3.683,4.793c-1.256,1.634-3.598,1.94-5.232,0.685c-1.634-1.256-1.94-3.598-0.684-5.232 L1616.497,586.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1629.221,571.14l3.914-4.606c1.297-1.526,3.585-1.712,5.112-0.414 c1.518,1.29,1.709,3.563,0.434,5.089l-3.877,4.637c-1.293,1.546-3.595,1.752-5.142,0.458c-1.547-1.293-1.752-3.595-0.459-5.142 L1629.221,571.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1642.598,555.869l4.109-4.432c1.332-1.436,3.575-1.521,5.011-0.189 c1.429,1.324,1.519,3.553,0.209,4.989l-4.074,4.465c-1.329,1.457-3.587,1.56-5.043,0.231c-1.457-1.329-1.56-3.586-0.231-5.043 L1642.598,555.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1656.638,541.197l4.307-4.24c1.364-1.343,3.558-1.325,4.9,0.038 c1.336,1.358,1.324,3.536-0.019,4.881l-4.273,4.274c-1.363,1.363-3.572,1.363-4.935,0.001c-1.363-1.362-1.363-3.572-0.001-4.934 L1656.638,541.197z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1671.35,527.192l4.508-4.026c1.394-1.245,3.534-1.124,4.779,0.269 c1.239,1.387,1.125,3.513-0.25,4.761l-4.475,4.063c-1.394,1.265-3.55,1.161-4.815-0.233c-1.265-1.394-1.161-3.55,0.233-4.815 L1671.35,527.192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1686.743,513.929l4.715-3.782c1.42-1.138,3.494-0.911,4.633,0.51 c1.131,1.41,0.912,3.466-0.481,4.61l-4.673,3.832c-1.421,1.166-3.518,0.959-4.684-0.462c-1.166-1.421-0.958-3.519,0.463-4.684 C1686.719,513.947,1686.738,513.933,1686.743,513.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1702.846,501.528l4.92-3.512c1.422-1.015,3.398-0.685,4.413,0.738 c1.007,1.41,0.688,3.366-0.704,4.388l-4.873,3.576c-1.426,1.046-3.431,0.738-4.477-0.689c-1.046-1.426-0.739-3.431,0.688-4.477 C1702.818,501.548,1702.839,501.532,1702.846,501.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1719.628,490.057l5.117-3.217c1.418-0.89,3.289-0.463,4.18,0.954 c0.884,1.406,0.469,3.259-0.921,4.159l-5.075,3.283c-1.424,0.921-3.326,0.513-4.247-0.911c-0.921-1.424-0.514-3.326,0.911-4.247 C1719.601,490.074,1719.622,490.061,1719.628,490.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1737.073,479.614l5.304-2.887c1.407-0.765,3.168-0.246,3.933,1.161 c0.759,1.396,0.252,3.14-1.128,3.915l-5.266,2.956c-1.416,0.795-3.207,0.291-4.002-1.124c-0.795-1.415-0.291-3.207,1.125-4.002 C1737.046,479.629,1737.067,479.617,1737.073,479.614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1755.149,470.31l5.489-2.529c1.388-0.639,3.033-0.033,3.672,1.357 c0.634,1.376,0.041,3.005-1.323,3.656l-5.456,2.601c-1.4,0.667-3.075,0.074-3.743-1.326c-0.667-1.4-0.073-3.075,1.326-3.743 C1755.122,470.323,1755.142,470.314,1755.149,470.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1773.819,462.255l5.653-2.137c1.362-0.514,2.883,0.172,3.398,1.535 c0.51,1.351-0.163,2.859-1.502,3.386l-5.625,2.209c-1.375,0.541-2.929-0.136-3.469-1.512c-0.54-1.375,0.136-2.928,1.512-3.469 C1773.793,462.265,1773.813,462.257,1773.819,462.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1793.018,455.558l5.796-1.714c1.326-0.391,2.719,0.366,3.112,1.692 c0.389,1.315-0.355,2.697-1.661,3.103l-5.772,1.788c-1.342,0.416-2.767-0.334-3.183-1.677c-0.416-1.342,0.335-2.767,1.677-3.182 C1792.992,455.566,1793.012,455.56,1793.018,455.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1812.662,450.322l5.913-1.251c1.273-0.268,2.523,0.545,2.792,1.818 c0.266,1.258-0.529,2.496-1.777,2.783l-5.89,1.354c-1.297,0.298-2.589-0.511-2.887-1.808c-0.298-1.297,0.511-2.589,1.808-2.887 C1812.63,450.329,1812.652,450.324,1812.662,450.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1832.652,446.663l5.993-0.782c1.193-0.156,2.287,0.685,2.443,1.879 c0.154,1.18-0.669,2.263-1.841,2.437l-5.978,0.887c-1.219,0.181-2.354-0.661-2.535-1.88c-0.181-1.22,0.661-2.355,1.88-2.536 C1832.622,446.667,1832.643,446.664,1832.652,446.663z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1852.856,444.597l4.741-0.252c1.111-0.059,2.06,0.794,2.118,1.905 c0.058,1.099-0.777,2.038-1.87,2.116l-4.736,0.332c-1.132,0.08-2.115-0.774-2.194-1.906c-0.079-1.131,0.774-2.114,1.906-2.194 C1852.829,444.599,1852.848,444.597,1852.856,444.597z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M992.833,1522.025l6.019-0.559c1.142-0.106,2.153,0.734,2.259,1.876 c0.106,1.141-0.734,2.152-1.875,2.259c-0.01,0.001-0.031,0.003-0.042,0.003l-6.029,0.438c-1.11,0.08-2.075-0.755-2.155-1.864 C990.93,1523.081,991.745,1522.127,992.833,1522.025z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1012.862,1520.066l6.015-0.643c1.252-0.134,2.375,0.772,2.509,2.025 c0.134,1.252-0.772,2.376-2.024,2.509c-0.012,0.001-0.034,0.003-0.046,0.004l-6.026,0.522c-1.221,0.105-2.296-0.799-2.402-2.019 C1010.784,1521.259,1011.666,1520.195,1012.862,1520.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1032.856,1517.826l6.009-0.716c1.354-0.161,2.583,0.807,2.744,2.16 c0.161,1.355-0.806,2.583-2.16,2.745c-0.008,0.001-0.03,0.003-0.038,0.004l-6.02,0.622c-1.331,0.138-2.521-0.829-2.658-2.16 C1030.597,1519.163,1031.546,1517.983,1032.856,1517.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1052.82,1515.349l6.001-0.801c1.435-0.192,2.753,0.817,2.945,2.251 c0.192,1.435-0.816,2.753-2.251,2.945c-0.008,0.001-0.031,0.004-0.039,0.005l-6.012,0.711c-1.413,0.167-2.693-0.843-2.86-2.256 C1050.438,1516.806,1051.429,1515.536,1052.82,1515.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1072.747,1512.585l5.978-0.888c1.515-0.225,2.925,0.82,3.15,2.335 c0.225,1.515-0.821,2.926-2.335,3.15c-0.009,0.002-0.033,0.005-0.041,0.006l-5.991,0.798c-1.493,0.199-2.865-0.85-3.063-2.343 C1070.247,1514.164,1071.276,1512.803,1072.747,1512.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1092.617,1509.528l5.965-0.977c1.594-0.262,3.098,0.819,3.359,2.413 c0.261,1.595-0.819,3.098-2.413,3.359c-0.009,0.001-0.034,0.005-0.044,0.007l-5.979,0.886c-1.573,0.234-3.037-0.852-3.271-2.425 C1090.004,1511.233,1091.069,1509.781,1092.617,1509.528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1112.437,1506.173l5.949-1.067c1.672-0.3,3.271,0.813,3.571,2.485 c0.3,1.672-0.812,3.272-2.485,3.572c-0.01,0.002-0.036,0.006-0.046,0.008l-5.964,0.977c-1.652,0.271-3.21-0.849-3.481-2.501 C1109.713,1508.011,1110.811,1506.465,1112.437,1506.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1132.2,1502.518l5.932-1.158c1.75-0.342,3.445,0.8,3.787,2.549c0.342,1.75-0.8,3.446-2.55,3.787 c-0.01,0.002-0.037,0.008-0.048,0.009l-5.949,1.069c-1.73,0.311-3.385-0.839-3.696-2.569 C1129.37,1504.491,1130.498,1502.851,1132.2,1502.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1151.901,1498.558l5.916-1.236c1.819-0.381,3.601,0.786,3.981,2.605 c0.38,1.819-0.786,3.601-2.605,3.981l-0.032,0.006l-5.928,1.179c-1.806,0.358-3.562-0.815-3.92-2.622 C1148.956,1500.677,1150.114,1498.932,1151.901,1498.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1171.547,1494.345l5.896-1.328c1.862-0.419,3.712,0.75,4.132,2.613 c0.419,1.862-0.75,3.713-2.613,4.131l-0.031,0.007l-5.908,1.274c-1.851,0.399-3.675-0.778-4.074-2.629 C1168.552,1496.572,1169.714,1494.758,1171.547,1494.345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1191.121,1489.82l5.874-1.423c1.905-0.461,3.824,0.709,4.286,2.615 c0.462,1.905-0.709,3.824-2.614,4.285l-0.032,0.008l-5.887,1.368c-1.894,0.441-3.787-0.738-4.228-2.632 C1188.082,1492.157,1189.246,1490.276,1191.121,1489.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1210.615,1484.978l5.859-1.523c1.947-0.506,3.935,0.663,4.441,2.61 c0.506,1.947-0.662,3.935-2.609,4.44l-0.033,0.009l-5.873,1.468c-1.936,0.485-3.899-0.693-4.383-2.629 C1207.536,1487.428,1208.699,1485.476,1210.615,1484.978z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1230.034,1479.812l5.831-1.62c1.987-0.552,4.046,0.612,4.598,2.599 c0.552,1.988-0.612,4.047-2.599,4.599l-0.033,0.009l-5.846,1.566c-1.978,0.529-4.01-0.644-4.54-2.622 C1226.919,1482.376,1228.078,1480.356,1230.034,1479.812z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1249.359,1474.32l5.801-1.719c2.027-0.601,4.157,0.556,4.757,2.582 c0.6,2.027-0.556,4.157-2.583,4.757l-0.034,0.01l-5.817,1.665c-2.018,0.577-4.121-0.59-4.699-2.608 C1246.211,1477.004,1247.363,1474.911,1249.359,1474.32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1268.582,1468.499l5.769-1.819c2.065-0.65,4.267,0.496,4.917,2.561 c0.651,2.065-0.495,4.267-2.56,4.917l-0.034,0.011l-5.785,1.766c-2.056,0.627-4.232-0.531-4.859-2.587 C1265.406,1471.303,1266.549,1469.14,1268.582,1468.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1287.705,1462.34l5.734-1.919c2.102-0.703,4.376,0.43,5.08,2.532 c0.704,2.101-0.43,4.375-2.532,5.079l-0.035,0.012l-5.752,1.867c-2.094,0.679-4.341-0.467-5.021-2.561 C1284.504,1465.269,1285.635,1463.035,1287.705,1462.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1306.708,1455.847l5.697-2.021c2.137-0.758,4.484,0.359,5.243,2.497 c0.758,2.136-0.359,4.484-2.496,5.242l-0.036,0.013l-5.716,1.969c-2.13,0.734-4.45-0.398-5.184-2.527 C1303.487,1458.901,1304.603,1456.595,1306.708,1455.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1325.583,1449.013l5.658-2.125c2.171-0.814,4.592,0.284,5.407,2.454 c0.815,2.171-0.284,4.592-2.454,5.407l-0.036,0.013l-5.677,2.073c-2.164,0.79-4.558-0.324-5.348-2.487 C1322.346,1452.198,1323.444,1449.818,1325.583,1449.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1344.324,1441.846l5.623-2.211c2.191-0.862,4.666,0.215,5.528,2.406 c0.862,2.192-0.216,4.667-2.407,5.528l-0.012,0.005l-5.63,2.195c-2.189,0.853-4.655-0.23-5.508-2.419 C1341.065,1445.161,1342.136,1442.7,1344.324,1441.846z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1362.942,1434.381l5.579-2.317c2.19-0.91,4.703,0.128,5.612,2.319 c0.909,2.19-0.128,4.702-2.318,5.612l-0.012,0.005l-5.586,2.3c-2.188,0.901-4.692-0.142-5.593-2.33 C1359.723,1437.781,1360.754,1435.282,1362.942,1434.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1381.41,1426.565l5.533-2.423c2.188-0.959,4.738,0.037,5.696,2.225 c0.958,2.188-0.038,4.739-2.226,5.697l-0.012,0.005l-5.54,2.407c-2.186,0.949-4.728-0.053-5.677-2.239 C1378.234,1430.052,1379.224,1427.516,1381.41,1426.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1399.72,1418.396l5.484-2.531c2.184-1.007,4.771-0.054,5.779,2.13 c1.008,2.184,0.054,4.771-2.129,5.779l-0.012,0.005l-5.492,2.514c-2.182,1-4.761,0.04-5.76-2.141 C1396.591,1421.969,1397.538,1419.395,1399.72,1418.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1417.865,1409.869l5.433-2.639c2.179-1.059,4.803-0.151,5.861,2.028 c1.058,2.179,0.15,4.803-2.029,5.862l-0.012,0.006l-5.441,2.623c-2.177,1.05-4.793,0.136-5.843-2.042 C1414.785,1413.529,1415.688,1410.919,1417.865,1409.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1435.835,1400.983l5.38-2.749c2.172-1.111,4.832-0.249,5.942,1.923 c1.11,2.172,0.249,4.832-1.923,5.943l-0.012,0.006l-5.388,2.732c-2.171,1.101-4.823,0.234-5.924-1.937 C1432.809,1404.73,1433.664,1402.084,1435.835,1400.983z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1453.624,1391.734l5.324-2.859c2.164-1.162,4.86-0.35,6.022,1.814s0.35,4.86-1.814,6.022 l-0.012,0.006l-5.332,2.843c-2.163,1.153-4.851,0.334-6.004-1.829C1450.654,1395.568,1451.461,1392.886,1453.624,1391.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1471.22,1382.12l5.266-2.972c2.154-1.216,4.885-0.454,6.1,1.699 c1.215,2.154,0.455,4.885-1.699,6.101l-0.012,0.006l-5.275,2.956c-2.153,1.206-4.876,0.439-6.083-1.715 C1468.312,1386.043,1469.067,1383.326,1471.22,1382.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1488.609,1372.133l5.204-3.087c2.142-1.27,4.907-0.564,6.178,1.578 c1.27,2.141,0.564,4.908-1.578,6.178l-0.012,0.007l-5.214,3.071c-2.141,1.261-4.899,0.548-6.16-1.593 C1485.766,1376.146,1486.468,1373.395,1488.609,1372.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1505.781,1361.773l5.13-3.195c2.128-1.326,4.927-0.675,6.253,1.453 c1.325,2.128,0.675,4.927-1.453,6.252l-0.012,0.008l-5.14,3.179c-2.128,1.316-4.919,0.658-6.235-1.47 C1503.007,1365.873,1503.653,1363.089,1505.781,1361.773z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1522.716,1351.046l5.059-3.305c2.113-1.381,4.945-0.787,6.325,1.326 c1.38,2.112,0.787,4.944-1.326,6.325l-0.012,0.007l-5.07,3.29c-2.113,1.371-4.937,0.77-6.309-1.342 C1520.014,1355.234,1520.604,1352.417,1522.716,1351.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1539.413,1339.954l4.986-3.415c2.096-1.436,4.959-0.901,6.395,1.195 c1.436,2.095,0.901,4.959-1.195,6.395l-0.012,0.008l-4.996,3.401c-2.096,1.426-4.952,0.884-6.379-1.212 C1536.786,1344.229,1537.317,1341.38,1539.413,1339.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1555.862,1328.498l4.909-3.525c2.078-1.492,4.971-1.017,6.463,1.061 c1.492,2.078,1.017,4.972-1.061,6.464l-0.011,0.008l-4.92,3.51c-2.078,1.482-4.965,0.999-6.447-1.079 C1553.312,1332.859,1553.784,1329.981,1555.862,1328.498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1572.052,1316.683l4.83-3.633c2.058-1.547,4.98-1.133,6.528,0.924 c1.548,2.058,1.134,4.98-0.924,6.528l-0.011,0.009l-4.841,3.618c-2.058,1.539-4.974,1.116-6.512-0.941 C1569.584,1321.129,1569.994,1318.222,1572.052,1316.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1587.996,1304.54l4.757-3.727c2.018-1.582,4.936-1.228,6.518,0.791 c1.581,2.018,1.235,4.93-0.783,6.511l-4.75,3.738c-2.018,1.588-4.94,1.239-6.528-0.778c-1.588-2.018-1.239-4.94,0.778-6.529 L1587.996,1304.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1603.673,1292.055l4.672-3.834c1.973-1.619,4.885-1.333,6.504,0.64 c1.619,1.972,1.34,4.878-0.633,6.497l-4.664,3.844c-1.972,1.626-4.889,1.345-6.514-0.628c-1.625-1.972-1.344-4.889,0.628-6.514 L1603.673,1292.055z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1619.063,1279.218l4.583-3.94c1.927-1.656,4.831-1.437,6.487,0.49 c1.656,1.926,1.444,4.825-0.482,6.481l-4.575,3.95c-1.926,1.662-4.834,1.449-6.497-0.477c-1.662-1.925-1.449-4.834,0.477-6.496 L1619.063,1279.218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1634.155,1266.033l4.491-4.045c1.879-1.692,4.774-1.541,6.467,0.338 c1.692,1.879,1.548,4.768-0.331,6.46l-4.483,4.055c-1.878,1.698-4.778,1.552-6.476-0.326s-1.553-4.778,0.325-6.477 L1634.155,1266.033z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1648.936,1252.503l4.395-4.148c1.831-1.727,4.715-1.645,6.443,0.186 c1.728,1.831,1.651,4.709-0.18,6.436l-4.387,4.158c-1.83,1.733-4.719,1.656-6.452-0.173c-1.734-1.83-1.656-4.719,0.173-6.452 L1648.936,1252.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1663.396,1238.63l4.296-4.251c1.781-1.763,4.653-1.747,6.416,0.034 c1.762,1.781,1.754,4.646-0.027,6.409l-4.287,4.259c-1.78,1.769-4.656,1.759-6.425-0.021c-1.769-1.78-1.759-4.656,0.021-6.425 L1663.396,1238.63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1677.522,1224.419l4.2-4.36c1.73-1.795,4.589-1.848,6.385-0.119 c1.796,1.73,1.856,4.582,0.125,6.378l-4.19,4.368c-1.729,1.802-4.591,1.861-6.394,0.133c-1.802-1.729-1.861-4.592-0.132-6.394 L1677.522,1224.419z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1691.307,1209.866l4.091-4.458c1.678-1.829,4.521-1.951,6.35-0.272 c1.829,1.678,1.957,4.514,0.279,6.344l-4.082,4.466c-1.677,1.835-4.524,1.962-6.358,0.286c-1.835-1.677-1.963-4.524-0.286-6.359 L1691.307,1209.866z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1704.732,1194.985l3.979-4.555c1.625-1.86,4.451-2.051,6.312-0.426 c1.861,1.625,2.058,4.443,0.433,6.305l-3.969,4.563c-1.624,1.866-4.453,2.064-6.32,0.44c-1.867-1.623-2.064-4.452-0.44-6.319 L1704.732,1194.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1717.787,1179.774l3.862-4.651c1.571-1.892,4.378-2.151,6.269-0.58 c1.892,1.571,2.157,4.37,0.587,6.261l-3.852,4.66c-1.569,1.897-4.379,2.163-6.277,0.594c-1.898-1.569-2.164-4.379-0.595-6.277 L1717.787,1179.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1730.451,1164.248l3.742-4.745c1.515-1.922,4.301-2.251,6.223-0.736 c1.921,1.515,2.256,4.294,0.741,6.215l-3.732,4.754c-1.513,1.927-4.303,2.262-6.23,0.75c-1.927-1.514-2.263-4.303-0.75-6.231 L1730.451,1164.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1742.712,1148.411l3.618-4.838c1.458-1.951,4.222-2.349,6.172-0.89 c1.95,1.458,2.355,4.214,0.896,6.164l-3.608,4.847c-1.456,1.956-4.223,2.361-6.179,0.904c-1.956-1.456-2.361-4.222-0.905-6.179 L1742.712,1148.411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1754.557,1132.269l3.49-4.929c1.401-1.978,4.139-2.446,6.118-1.046 c1.978,1.401,2.451,4.131,1.051,6.11l-3.48,4.937c-1.398,1.983-4.14,2.458-6.124,1.06c-1.984-1.398-2.458-4.139-1.06-6.124 L1754.557,1132.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1765.979,1115.82l3.358-5.019c1.341-2.005,4.054-2.542,6.058-1.201 c2.005,1.342,2.547,4.046,1.206,6.051l-3.348,5.026c-1.339,2.011-4.054,2.555-6.065,1.216c-2.01-1.339-2.554-4.055-1.215-6.064 L1765.979,1115.82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1776.959,1099.075l3.223-5.107c1.281-2.029,3.965-2.636,5.995-1.356 c2.03,1.281,2.642,3.957,1.361,5.987l-3.212,5.113c-1.279,2.036-3.965,2.649-6.001,1.371c-2.036-1.279-2.649-3.965-1.371-6.001 L1776.959,1099.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1787.485,1082.042l3.083-5.192c1.219-2.054,3.873-2.731,5.927-1.511 c2.054,1.22,2.735,3.865,1.515,5.919l-3.072,5.199c-1.217,2.06-3.873,2.743-5.932,1.526c-2.059-1.217-2.742-3.873-1.525-5.933 L1787.485,1082.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1797.537,1064.737l2.94-5.276c1.157-2.077,3.778-2.821,5.854-1.664 c2.076,1.157,2.826,3.77,1.669,5.846l-2.929,5.282c-1.154,2.083-3.778,2.834-5.859,1.68c-2.082-1.155-2.834-3.778-1.679-5.86 L1797.537,1064.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1807.111,1047.157l2.793-5.358c1.093-2.097,3.68-2.911,5.777-1.818 c2.097,1.093,2.916,3.672,1.822,5.769l-2.782,5.364c-1.09,2.102-3.679,2.923-5.782,1.833c-2.103-1.09-2.924-3.679-1.833-5.782 L1807.111,1047.157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1816.193,1029.309l2.643-5.432c1.03-2.116,3.58-2.997,5.696-1.967 c2.116,1.03,3.001,3.573,1.971,5.689l-2.632,5.438c-1.027,2.121-3.579,3.009-5.701,1.982s-3.009-3.58-1.982-5.701 L1816.193,1029.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1824.806,1011.216l2.519-5.486c0.973-2.119,3.48-3.049,5.599-2.076 c2.111,0.969,3.04,3.462,2.087,5.575l-2.484,5.502c-0.964,2.136-3.476,3.085-5.611,2.121c-2.135-0.964-3.085-3.476-2.121-5.611 L1824.806,1011.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1833.031,992.931l2.402-5.536c0.914-2.107,3.363-3.074,5.47-2.16 c2.098,0.91,3.066,3.345,2.171,5.446l-2.366,5.552c-0.905,2.122-3.358,3.109-5.481,2.204c-2.122-0.904-3.11-3.358-2.205-5.48 L1833.031,992.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1840.897,974.473l2.304-5.58c0.863-2.089,3.257-3.085,5.347-2.221 c2.082,0.859,3.076,3.238,2.232,5.323l-2.268,5.594c-0.854,2.105-3.252,3.119-5.358,2.265c-2.105-0.853-3.12-3.252-2.266-5.357 L1840.897,974.473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1848.463,955.872l2.225-5.613c0.82-2.07,3.163-3.082,5.232-2.262 c2.061,0.817,3.073,3.145,2.271,5.208l-2.189,5.628c-0.811,2.084-3.158,3.116-5.242,2.306s-3.117-3.158-2.306-5.242 L1848.463,955.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1855.79,937.168l2.166-5.64c0.785-2.045,3.08-3.066,5.125-2.28c2.037,0.782,3.057,3.062,2.29,5.1 l-2.13,5.653c-0.776,2.06-3.075,3.101-5.135,2.325c-2.06-0.776-3.101-3.075-2.325-5.134L1855.79,937.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1862.947,918.374l2.125-5.657c0.758-2.018,3.008-3.039,5.026-2.28 c2.009,0.754,3.03,2.991,2.289,5.002l-2.089,5.671c-0.749,2.032-3.003,3.073-5.036,2.323c-2.032-0.749-3.073-3.003-2.324-5.036 L1862.947,918.374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1869.997,899.516l2.104-5.667c0.738-1.987,2.947-3,4.934-2.263 c1.979,0.736,2.991,2.932,2.27,4.913l-2.068,5.68c-0.729,2.002-2.943,3.035-4.945,2.305c-2.002-0.729-3.034-2.942-2.305-4.944 L1869.997,899.516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1877.005,880.622l2.103-5.669c0.725-1.955,2.897-2.951,4.851-2.226 c1.947,0.722,2.943,2.88,2.234,4.829l-2.067,5.683c-0.716,1.968-2.893,2.984-4.862,2.268c-1.969-0.716-2.984-2.893-2.269-4.862 L1877.005,880.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1884.034,861.719l2.12-5.663c0.718-1.919,2.857-2.892,4.776-2.174 c1.911,0.716,2.884,2.841,2.182,4.754l-2.084,5.677c-0.71,1.933-2.853,2.926-4.787,2.215c-1.934-0.71-2.925-2.853-2.215-4.787 L1884.034,861.719z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1891.147,842.835l2.157-5.648c0.718-1.882,2.826-2.824,4.707-2.106 c1.874,0.716,2.816,2.81,2.114,4.686l-2.121,5.662c-0.71,1.896-2.823,2.857-4.719,2.146c-1.896-0.71-2.857-2.822-2.147-4.719 L1891.147,842.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1898.411,823.998l2.213-5.627c0.724-1.841,2.804-2.746,4.645-2.022 c1.834,0.721,2.739,2.789,2.031,4.624l-2.177,5.639c-0.716,1.856-2.801,2.78-4.657,2.064c-1.856-0.717-2.779-2.802-2.063-4.658 L1898.411,823.998z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1905.887,805.234l2.288-5.594c0.735-1.799,2.79-2.661,4.588-1.925 c1.791,0.733,2.653,2.774,1.933,4.567l-2.252,5.61c-0.728,1.813-2.788,2.692-4.601,1.964s-2.693-2.788-1.965-4.601 L1905.887,805.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1913.64,786.577l2.386-5.565c0.752-1.753,2.783-2.565,4.536-1.813 c1.746,0.749,2.559,2.766,1.823,4.514l-0.007,0.016l-2.343,5.562c-0.743,1.769-2.779,2.6-4.548,1.857 c-1.769-0.743-2.6-2.779-1.857-4.548L1913.64,786.577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1921.746,768.049l2.502-5.502c0.775-1.704,2.785-2.457,4.49-1.682 c1.698,0.772,2.451,2.77,1.691,4.471l-2.467,5.516c-0.769,1.72-2.786,2.49-4.505,1.722c-1.719-0.769-2.49-2.786-1.721-4.505 L1921.746,768.049z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1930.275,749.707l2.645-5.434c0.802-1.648,2.787-2.332,4.434-1.531 c1.637,0.797,2.323,2.764,1.544,4.405l-2.593,5.46c-0.793,1.669-2.789,2.38-4.458,1.587c-1.669-0.793-2.379-2.789-1.586-4.458 L1930.275,749.707z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1939.313,731.602l2.798-5.357c0.819-1.569,2.754-2.176,4.322-1.357 c1.557,0.814,2.166,2.729,1.373,4.29l-2.737,5.389c-0.81,1.595-2.758,2.23-4.352,1.421c-1.594-0.81-2.23-2.758-1.42-4.352 C1939.299,731.628,1939.31,731.607,1939.313,731.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1948.868,713.756l2.958-5.27c0.835-1.488,2.718-2.018,4.206-1.182 c1.477,0.829,2.008,2.693,1.199,4.176l-2.898,5.303c-0.827,1.514-2.725,2.071-4.239,1.243c-1.514-0.827-2.07-2.725-1.243-4.239 C1948.853,713.783,1948.865,713.762,1948.868,713.756z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1958.979,696.214l3.132-5.168c0.852-1.406,2.681-1.854,4.087-1.002 c1.395,0.845,1.847,2.656,1.02,4.058l-3.074,5.204c-0.845,1.431-2.691,1.906-4.122,1.06c-1.431-0.845-1.906-2.69-1.061-4.122 C1958.964,696.239,1958.976,696.22,1958.979,696.214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1969.692,679.026l3.32-5.05c0.868-1.321,2.642-1.688,3.963-0.819 c1.311,0.862,1.681,2.619,0.837,3.936l-3.262,5.088c-0.863,1.347-2.654,1.738-4.001,0.875c-1.346-0.864-1.738-2.655-0.875-4.002 C1969.677,679.049,1969.689,679.031,1969.692,679.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1981.051,662.251l3.52-4.914c0.884-1.234,2.6-1.517,3.834-0.633 c1.225,0.878,1.512,2.577,0.652,3.809l-3.464,4.953c-0.881,1.259-2.615,1.566-3.874,0.686c-1.259-0.88-1.566-2.615-0.686-3.874 C1981.036,662.273,1981.048,662.256,1981.051,662.251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1993.098,645.957l3.732-4.754c0.898-1.145,2.554-1.344,3.698-0.446 c1.136,0.891,1.34,2.531,0.464,3.675l-3.677,4.796c-0.897,1.17-2.572,1.391-3.741,0.494c-1.169-0.896-1.391-2.571-0.494-3.741 C1993.083,645.977,1993.095,645.961,1993.098,645.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2005.872,630.22l3.957-4.575c0.911-1.053,2.502-1.168,3.555-0.257 c1.045,0.904,1.165,2.48,0.276,3.534l-3.906,4.619c-0.911,1.077-2.523,1.212-3.6,0.301c-1.077-0.911-1.212-2.522-0.302-3.599 C2005.857,630.238,2005.869,630.224,2005.872,630.22z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2019.407,615.124l4.179-4.356c0.92-0.959,2.443-0.991,3.402-0.07 c0.952,0.913,0.989,2.423,0.089,3.383l-4.13,4.402c-0.922,0.984-2.467,1.033-3.45,0.11c-0.983-0.922-1.032-2.466-0.11-3.45 C2019.391,615.141,2019.404,615.127,2019.407,615.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2033.718,600.77l4.42-4.122c0.926-0.864,2.377-0.814,3.24,0.112 c0.857,0.92,0.813,2.358-0.094,3.224l-4.373,4.172c-0.93,0.887-2.403,0.852-3.29-0.078c-0.887-0.93-0.852-2.402,0.077-3.289 C2033.702,600.785,2033.714,600.774,2033.718,600.77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2048.826,587.246l4.656-3.854c0.927-0.767,2.301-0.639,3.068,0.289 c0.762,0.92,0.638,2.281-0.271,3.051l-4.612,3.906c-0.933,0.79-2.329,0.675-3.119-0.258c-0.79-0.932-0.674-2.329,0.259-3.119 C2048.81,587.259,2048.823,587.248,2048.826,587.246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2064.722,574.656l4.881-3.552c0.922-0.671,2.214-0.467,2.885,0.454 c0.666,0.916,0.469,2.197-0.436,2.871l-4.841,3.606c-0.929,0.694-2.245,0.501-2.938-0.429c-0.693-0.93-0.501-2.245,0.429-2.937 C2064.706,574.668,2064.719,574.658,2064.722,574.656z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104676851623225795660000011067110807986401704_",
    gradientUnits: "userSpaceOnUse",
    x1: 1875.0741,
    y1: 431.0596,
    x2: 2024.6931,
    y2: 431.0596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104676851623225795660000011067110807986401704_)"
    },
    d: "M1958.635,364.873l15.557,31.522 c1.422,2.88,4.169,4.877,7.348,5.339l34.786,5.055c8.005,1.163,11.201,11,5.409,16.646l-25.172,24.536 c-2.3,2.242-3.35,5.472-2.807,8.638l5.942,34.646c1.367,7.972-7.001,14.052-14.16,10.288l-31.114-16.357 c-2.843-1.495-6.24-1.495-9.083,0l-31.114,16.357c-7.16,3.764-15.527-2.316-14.16-10.288l5.942-34.646 c0.543-3.166-0.507-6.396-2.807-8.638l-25.172-24.536c-5.792-5.646-2.596-15.483,5.409-16.646l34.786-5.055 c3.179-0.462,5.927-2.458,7.348-5.339l15.557-31.522C1944.712,357.62,1955.055,357.62,1958.635,364.873z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159472029999905238670000016388264026717102993_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.1017,
    y1: 381.0979,
    x2: 1859.3728,
    y2: 572.8159
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000159472029999905238670000016388264026717102993_)"
    },
    d: "M1990.082,496.791 c-0.607,0-1.212-0.157-1.8-0.465l-31.114-16.358c-2.238-1.176-4.757-1.798-7.285-1.798c-2.528,0-5.047,0.622-7.285,1.798 l-31.114,16.358c-0.588,0.309-1.193,0.465-1.8,0.465c-1.118,0-2.236-0.534-2.99-1.429c-0.512-0.607-1.069-1.639-0.817-3.11 l5.942-34.646c0.871-5.079-0.812-10.259-4.502-13.857l-25.172-24.536c-1.552-1.513-1.201-3.274-0.978-3.961 c0.223-0.687,0.974-2.318,3.119-2.63l34.786-5.055c5.099-0.741,9.506-3.942,11.787-8.564l15.557-31.522 c0.959-1.944,2.743-2.154,3.465-2.154c0.722,0,2.505,0.21,3.465,2.154l15.557,31.522c2.281,4.622,6.688,7.823,11.787,8.564 l34.786,5.055c2.146,0.312,2.896,1.943,3.119,2.63c0.223,0.687,0.575,2.448-0.978,3.961l-25.172,24.536 c-3.69,3.597-5.373,8.777-4.502,13.856l5.942,34.646c0.252,1.471-0.305,2.503-0.817,3.11 C1992.317,496.256,1991.2,496.791,1990.082,496.791z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M1916.887,449.185c-0.373,0-0.719-0.238-0.841-0.611 c-1.031-3.173-2.84-6.082-5.23-8.412l-9.577-9.335c-0.349-0.341-0.357-0.9-0.016-1.25c0.341-0.35,0.901-0.357,1.25-0.016 l9.577,9.335c2.595,2.529,4.558,5.687,5.677,9.132c0.151,0.464-0.103,0.963-0.568,1.114 C1917.07,449.171,1916.978,449.185,1916.887,449.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M1935.692,477.823c-0.318,0-0.625-0.172-0.783-0.473 c-0.227-0.432-0.061-0.967,0.371-1.194l4.165-2.19c3.207-1.686,6.817-2.577,10.439-2.577c3.622,0,7.232,0.891,10.44,2.577 c0.432,0.227,0.598,0.762,0.371,1.194c-0.227,0.433-0.762,0.599-1.194,0.371c-2.955-1.553-6.28-2.374-9.617-2.374 s-6.662,0.821-9.616,2.373l-4.165,2.19C1935.971,477.79,1935.83,477.823,1935.692,477.823z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M1978.99,484.853c-0.694,0-1.392-0.103-2.077-0.311 c-0.467-0.143-0.73-0.637-0.587-1.104c0.142-0.467,0.636-0.73,1.104-0.587c1.791,0.547,3.72,0.118,5.158-1.15 c1.442-1.27,2.082-3.09,1.755-4.995l-3.079-17.954c-1.248-7.279,1.164-14.702,6.452-19.857l13.044-12.715 c1.517-1.479,2.032-3.564,1.377-5.579c-0.655-2.015-2.297-3.399-4.393-3.704l-18.026-2.62 c-7.309-1.061-13.623-5.649-16.892-12.272l-8.062-16.335c-0.938-1.9-2.762-3.034-4.88-3.034c-2.118,0-3.943,1.134-4.88,3.034 l-8.062,16.335c-3.269,6.623-9.583,11.211-16.891,12.272l-18.026,2.62c-1.075,0.156-2.056,0.607-2.836,1.303 c-0.365,0.325-0.923,0.293-1.249-0.071c-0.325-0.365-0.293-0.923,0.071-1.249c1.04-0.928,2.34-1.528,3.759-1.734l18.026-2.619 c6.732-0.978,12.549-5.204,15.56-11.305l8.062-16.335c1.224-2.479,3.702-4.02,6.467-4.02s5.243,1.54,6.466,4.02l8.062,16.335 c3.011,6.101,8.828,10.327,15.561,11.305l18.026,2.619c2.736,0.398,4.967,2.278,5.821,4.908c0.854,2.63,0.155,5.462-1.825,7.392 l-13.044,12.715c-4.871,4.748-7.093,11.586-5.943,18.291l3.079,17.954c0.426,2.486-0.444,4.961-2.329,6.621 C1982.401,484.222,1980.712,484.852,1978.99,484.853z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089550190302560460540000008945429689828140184_",
    gradientUnits: "userSpaceOnUse",
    x1: 2063.4084,
    y1: 522.2848,
    x2: 2174.9443,
    y2: 522.2848
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089550190302560460540000008945429689828140184_)"
    },
    d: "M2132.458,471.559l7.439,25.492 c0.68,2.329,2.462,4.175,4.767,4.936l25.217,8.323c5.803,1.915,6.89,9.653,1.841,13.094l-21.945,14.953 c-2.005,1.366-3.21,3.632-3.221,6.058l-0.123,26.555c-0.028,6.11-7.052,9.536-11.884,5.797l-21.002-16.25 c-1.919-1.485-4.446-1.93-6.757-1.191l-25.293,8.089c-5.82,1.861-11.249-3.759-9.186-9.511l8.965-24.996 c0.819-2.284,0.462-4.825-0.955-6.795l-15.509-21.556c-3.569-4.96,0.1-11.859,6.207-11.675l26.543,0.802 c2.426,0.073,4.732-1.052,6.167-3.008l15.708-21.411C2123.051,464.336,2130.746,465.693,2132.458,471.559z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046316734740257909540000001742863968216763016_",
    gradientUnits: "userSpaceOnUse",
    x1: 1886.2157,
    y1: 294.385,
    x2: 1790.4777,
    y2: 439.2195,
    gradientTransform: "matrix(0.9848 0.1736 -0.1736 0.9848 344.3236 -130.1267)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046316734740257909540000001742863968216763016_)"
    },
    d: "M2138.551,573.826 c-0.451-0.079-0.881-0.276-1.278-0.582l-21.002-16.25c-1.511-1.169-3.303-1.962-5.184-2.293 c-1.881-0.332-3.837-0.199-5.656,0.382l-25.293,8.089c-0.478,0.153-0.948,0.19-1.4,0.11c-0.832-0.147-1.593-0.691-2.037-1.455 c-0.301-0.519-0.58-1.36-0.199-2.421l8.965-24.996c1.314-3.665,0.741-7.739-1.532-10.899l-15.509-21.556 c-0.956-1.329-0.464-2.593-0.208-3.075c0.256-0.482,1.029-1.597,2.666-1.547l26.543,0.802c3.891,0.118,7.589-1.686,9.892-4.825 l15.708-21.411c0.969-1.32,2.323-1.243,2.86-1.148c0.537,0.095,1.836,0.485,2.295,2.057l7.439,25.491 c1.091,3.738,3.949,6.697,7.646,7.917l25.217,8.323c1.555,0.513,1.9,1.826,1.976,2.366c0.076,0.54,0.106,1.896-1.247,2.818 l-21.945,14.953c-3.217,2.192-5.149,5.825-5.167,9.718l-0.124,26.555c-0.005,1.127-0.555,1.822-1.015,2.207 C2140.284,573.721,2139.383,573.972,2138.551,573.826z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M2090.341,528.808c-0.278-0.049-0.504-0.271-0.546-0.565 c-0.351-2.496-1.315-4.897-2.787-6.944l-5.9-8.201c-0.215-0.299-0.147-0.717,0.152-0.932c0.299-0.216,0.717-0.147,0.932,0.152 l5.9,8.201c1.598,2.222,2.645,4.829,3.026,7.539c0.052,0.365-0.203,0.703-0.568,0.755 C2090.478,528.822,2090.408,528.82,2090.341,528.808z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M2100.574,552.581c-0.237-0.042-0.443-0.21-0.521-0.455 c-0.113-0.352,0.081-0.728,0.433-0.84l3.386-1.083c2.607-0.834,5.409-1.023,8.104-0.548c2.695,0.475,5.264,1.612,7.429,3.287 c0.292,0.226,0.345,0.646,0.12,0.937c-0.226,0.292-0.646,0.345-0.937,0.12c-1.994-1.543-4.361-2.59-6.843-3.028 c-2.483-0.438-5.064-0.263-7.465,0.505l-3.386,1.083C2100.786,552.593,2100.677,552.599,2100.574,552.581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    d: "M2131.865,563.489c-0.516-0.091-1.022-0.259-1.504-0.504 c-0.329-0.168-0.459-0.57-0.292-0.898s0.569-0.46,0.898-0.292c1.261,0.642,2.752,0.575,3.988-0.179 c1.24-0.756,1.954-2.026,1.961-3.486l0.064-13.761c0.026-5.579,2.794-10.785,7.405-13.926l11.372-7.749 c1.323-0.901,1.979-2.385,1.757-3.97c-0.223-1.585-1.263-2.831-2.783-3.332l-13.067-4.313c-5.298-1.748-9.395-5.99-10.958-11.346 l-3.855-13.21c-0.448-1.536-1.657-2.619-3.233-2.897c-1.576-0.278-3.082,0.327-4.029,1.617l-8.14,11.095 c-3.301,4.499-8.6,7.084-14.177,6.914l-13.754-0.415c-0.821-0.025-1.609,0.182-2.281,0.598c-0.314,0.194-0.725,0.097-0.919-0.217 c-0.194-0.314-0.097-0.725,0.217-0.919c0.895-0.554,1.941-0.83,3.024-0.797l13.754,0.416c5.137,0.155,10.019-2.226,13.059-6.37 l8.14-11.095c1.236-1.684,3.281-2.505,5.338-2.143c2.057,0.363,3.698,1.834,4.283,3.839l3.855,13.21 c1.44,4.934,5.213,8.841,10.094,10.451l13.067,4.313c1.983,0.655,3.396,2.346,3.687,4.415c0.291,2.069-0.601,4.084-2.327,5.26 l-11.372,7.749c-4.247,2.894-6.797,7.689-6.821,12.828l-0.064,13.761c-0.009,1.905-0.981,3.632-2.601,4.62 C2134.486,563.467,2133.146,563.715,2131.865,563.489z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087381855535073915710000004967319616860083631_",
    gradientUnits: "userSpaceOnUse",
    x1: 985.1083,
    y1: 1160.2683,
    x2: 1280.3201,
    y2: 817.6122
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000087381855535073915710000004967319616860083631_)"
    },
    cx: 1286.283,
    cy: 810.691,
    r: 220.091
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151528592595996385250000016672739820379294592_",
    gradientUnits: "userSpaceOnUse",
    x1: 1447.134,
    y1: 567.6909,
    x2: 574.1844,
    y2: 1886.469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000151528592595996385250000016672739820379294592_)"
    },
    cx: 1286.283,
    cy: 810.691,
    r: 212.773
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070098252700480513090000015195814230787440558_",
    gradientUnits: "userSpaceOnUse",
    x1: 1096.2445,
    y1: 142.737,
    x2: 1093.244,
    y2: 556.7787
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070098252700480513090000015195814230787440558_)"
    },
    d: "M1090.144,802.282 c-0.035,0-0.071,0-0.107-0.002c-1.111-0.059-1.964-1.007-1.906-2.117c0.436-8.35,1.406-16.735,2.882-24.925 c0.199-1.094,1.24-1.822,2.34-1.625c1.096,0.199,1.823,1.245,1.626,2.341c-1.447,8.023-2.397,16.239-2.825,24.417 C1092.097,801.448,1091.208,802.282,1090.144,802.282z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065792677003750444510000002350200183919699843_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.0886,
    y1: 143.6334,
    x2: 1217.0881,
    y2: 557.6756
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065792677003750444510000002350200183919699843_)"
    },
    d: "M1110.831,724.318 c-0.305,0-0.615-0.069-0.906-0.216c-0.994-0.502-1.392-1.714-0.89-2.705c33.979-67.316,101.896-109.134,177.249-109.134 c12.021,0,24.064,1.084,35.795,3.221c1.095,0.199,1.821,1.247,1.621,2.341c-0.199,1.096-1.238,1.832-2.343,1.621 c-11.493-2.093-23.293-3.154-35.073-3.154c-73.823,0-140.362,40.969-173.652,106.918 C1112.277,723.913,1111.568,724.318,1110.831,724.318z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.57,
      fill: "#FFFFFF"
    },
    cx: 1290.919,
    cy: 815.327,
    r: 180.086
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065050740936304620090000012551237446758682040_",
    gradientUnits: "userSpaceOnUse",
    x1: 1326.443,
    y1: 699.6628,
    x2: 900.8809,
    y2: 1293.5801
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065050740936304620090000012551237446758682040_)"
    },
    d: "M1346.055,747.278 c0,30.493-24.719,63.413-55.213,63.413s-55.213-32.919-55.213-63.413c0-30.493,24.719-52.126,55.213-52.126 S1346.055,716.785,1346.055,747.278z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000046328505909245913820000004427640330281072008_",
    gradientUnits: "userSpaceOnUse",
    x1: 1388.1305,
    y1: 743.8641,
    x2: 962.5686,
    y2: 1337.7809
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000046328505909245913820000004427640330281072008_)"
    },
    d: "M1222.323,928.092h134.784 c14.188,0,26.75-9.17,31.073-22.683l7.253-22.669c5.31-16.598-3.323-34.568-19.69-40.552 c-54.852-20.055-111.571-17.482-169.673,1.851c-16.277,5.416-25.31,22.827-20.818,39.383l5.585,20.587 C1194.693,918.224,1207.595,928.092,1222.323,928.092z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149354209591209135360000002777320057228619683_",
    gradientUnits: "userSpaceOnUse",
    x1: 1729.7606,
    y1: 1053.9048,
    x2: 1498.7725,
    y2: 846.9156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149354209591209135360000002777320057228619683_)"
    },
    d: "M1497.962,883.386l-0.38-12.631 l13.203-26.217c2.415-4.796,2.434-10.448,0.051-15.26l-14.957-30.198c0,0-8.638,65.547-10.91,70.995 c-2.272,5.448,6.163,15.236,6.163,15.236L1497.962,883.386z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000167371594376921681960000009136564579687290807_",
    gradientUnits: "userSpaceOnUse",
    x1: 1620.5063,
    y1: 914.7711,
    x2: 1696.2609,
    y2: 1045.3478
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000167371594376921681960000009136564579687290807_)"
    },
    d: "M1644.491,921.843 c0,0,14.116,6.866,16.712,14.754c2.082,6.329,17.692,7.145,19.233,19.591c0.796,6.426,5.552,11.573,11.953,12.554 c15.942,2.443,40.51,10.722,44.441,38.4c3,21.127-7.77,29.138-19.073,31.911c-8.302,2.036-13.819,10.111-12.14,18.493 c1.611,8.039-0.791,17.332-14.718,24.681c-31.209,16.468-62.377-39.014-62.377-39.014l-6.387-96.875L1644.491,921.843z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000018925407100479911810000005886965822516738227_",
    gradientUnits: "userSpaceOnUse",
    x1: 1688.3422,
    y1: 1100.1257,
    x2: 1457.3533,
    y2: 893.1359
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000018925407100479911810000005886965822516738227_)"
    },
    d: "M1497.582,870.755 c0,0,40.158,109.475,108.585,143.691c0,0-22.775,37.16-34.66,39.414c0,0-73.098-93.557-80.55-170.205L1497.582,870.755z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145031294367512750780000007506416226392743321_",
    gradientUnits: "userSpaceOnUse",
    x1: 1772.7317,
    y1: 1547.6727,
    x2: 1808.3431,
    y2: 1547.6727
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145031294367512750780000007506416226392743321_)"
    },
    d: "M1772.774,1529.282l2.02,16.603 c2.103,7.891,12.26,27.772,25.297,26.478c8.021-0.796,8.987-24.232,7.87-27.747c-2.037-6.409-5.764-16.03-11.137-21.692h-18.417 C1775.001,1522.923,1772.363,1525.902,1772.774,1529.282z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000037659023301032304310000003294213471512353936_",
    gradientUnits: "userSpaceOnUse",
    x1: 1622.699,
    y1: 1677.8152,
    x2: 1673.7953,
    y2: 1080.6271
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000037659023301032304310000003294213471512353936_)"
    },
    d: "M1628.523,1334.794l-3.109,18.286 c0,0,10.41,105.444,12.261,147.622c0.29,6.613-1.42,13.147-4.891,18.783l-18.101,29.395l46.004-27.146l0.916-5.614 l-7.531-10.354l9.864-118.124c0.579-6.939-0.852-13.898-4.124-20.045l-9.516-17.876L1628.523,1334.794z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140695013443228696400000012517699345287546255_",
    gradientUnits: "userSpaceOnUse",
    x1: 1646.6448,
    y1: 1531.3148,
    x2: 1704.0969,
    y2: 1531.3148
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140695013443228696400000012517699345287546255_)"
    },
    d: "M1611.654,1553.138h14.681 c2.748,0,5.339-1.261,7.015-3.439c4.577-5.947,14.059-17.549,18.593-17.852c6.104-0.408,5.323,21.291,5.323,21.291h3.421 l4.334-26.963c1.091-6.784-2.283-13.505-8.375-16.683l0,0c0,0-1.395,10.318-8.961,14.882 c-7.565,4.564-30.786,20.909-30.786,20.909s-2.844-0.406-5.967,0.159C1606.3,1546.279,1606.947,1553.138,1611.654,1553.138z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047032121163006642990000014115791403911634832_",
    gradientUnits: "userSpaceOnUse",
    x1: 1725.4822,
    y1: 1686.7007,
    x2: 1776.5919,
    y2: 1089.3562
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047032121163006642990000014115791403911634832_)"
    },
    d: "M1691.533,1343.479 c0,0,60.985,115.682,70.679,142.094c9.694,26.412,13.09,48.446,13.22,50.532c0.203,3.26,4.258,6.387,15.436,6.387 c5.769,0,8.594-2.312,9.977-4.55c1.18-1.91,1.241-4.299,0.247-6.312c-3.528-7.139-14.723-29.954-18.869-40.303 c-4.95-12.355-15.598-68.346-21.438-87.813c-5.84-19.468-12.441-40.584-37.872-60.036 C1722.913,1343.479,1705.456,1326.381,1691.533,1343.479z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062890744164683720910000000139681451023832750_",
    gradientUnits: "userSpaceOnUse",
    x1: 1573.7012,
    y1: 1306.3651,
    x2: 1529.7012,
    y2: 1544.3658
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062890744164683720910000000139681451023832750_)"
    },
    d: "M1653.008,1153.928 c-8.932-37.848,0.055-66.36,9.491-83.937c7.527-14.02,2.235-31.363-11.883-38.704c-22.064-11.474-44.449-16.841-44.449-16.841 s-43.718,31.962-38.532,56.979c3.04,14.663,30.73,87.826,30.73,87.826S1623.97,1171.369,1653.008,1153.928z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005962136520586980170000018264971676355333777_",
    gradientUnits: "userSpaceOnUse",
    x1: 1662.0116,
    y1: 1251.6268,
    x2: 1387.1403,
    y2: 1622.2871
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005962136520586980170000018264971676355333777_)"
    },
    d: "M1687.886,1186.929 c-6.402-19.287-34.878-33.001-34.878-33.001c-29.038,17.441-54.643,5.323-54.643,5.323s-5.742,21.948-1.779,42.345 s28.828,151.484,28.828,151.484c39.179,7.939,99.435-7.987,99.435-7.987C1699.894,1300.786,1694.288,1206.216,1687.886,1186.929 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008125895168674629880000005081333397350872989_",
    gradientUnits: "userSpaceOnUse",
    x1: 1637.4962,
    y1: 1047.864,
    x2: 1620.9971,
    y2: 975.8677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008125895168674629880000005081333397350872989_)"
    },
    d: "M1634.748,970.395l12.79,57.449 c1.224,5.06-3.389,4.232-8.505,3.268c-8.378-1.58-19.177-4.833-22.787-11.352c-0.367-0.663-0.551-1.414-0.655-2.165 l-5.495-39.837c-0.436-3.161,1.273-6.228,4.189-7.521l10.603-4.701C1628.972,963.725,1633.697,966.054,1634.748,970.395z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017485398325242342750000013686215229048155065_",
    gradientUnits: "userSpaceOnUse",
    x1: 1678.3679,
    y1: 956.7646,
    x2: 1599.3679,
    y2: 943.7645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017485398325242342750000013686215229048155065_)"
    },
    d: "M1619.741,915.695 c0,0-15.148,6.396-25.447,28.285c-10.3,21.889-2.608,31.995,7.053,33.383c9.661,1.387,24.109,1.176,39.392-12.964 C1656.022,950.258,1639.432,908.113,1619.741,915.695z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000180364678302809552470000005120100701017384121_",
    gradientUnits: "userSpaceOnUse",
    x1: 1626.4423,
    y1: 911.3275,
    x2: 1702.1965,
    y2: 1041.9038
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000180364678302809552470000005120100701017384121_)"
    },
    d: "M1630.466,952.713 c0,0,11.428-32.024-16.964-32.403l-6.681,4.669c0,0-10.417-17.755,6.681-26.23c17.098-8.476,37.11-1.475,44.386,21.561 c7.276,23.036,8.519,38.456-3.587,49.477c-12.105,11.021-17.094-1.475-17.094-1.475s6.592-10.308,3.909-15.823 c-2.684-5.515-8.873,1.141-8.873,1.141L1630.466,952.713z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017498566974067519730000005585943459059164843_",
    gradientUnits: "userSpaceOnUse",
    x1: 1677.6926,
    y1: 960.8679,
    x2: 1598.6927,
    y2: 947.8679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017498566974067519730000005585943459059164843_)"
    },
    d: "M1633.65,956.279 c0,0,5.778-16.496,13.486-9.927c7.708,6.57-6.265,15.238-11.735,18.046L1633.65,956.279z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140732877348795466850000011823159867386045337_",
    gradientUnits: "userSpaceOnUse",
    x1: 1696.8243,
    y1: 1049.3649,
    x2: 1465.8351,
    y2: 983.3679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000140732877348795466850000011823159867386045337_)"
    },
    d: "M1474.887,932.451 c0,0,33.662,116.939,169.405,105.948c8.684-0.703,16.313,5.732,16.988,14.419l0.365,4.694 c0.978,12.583-9.291,23.191-21.896,22.553c-45.148-2.284-142.106-20.014-175.339-127.288L1474.887,932.451z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095297374800860447040000005805646695524537532_",
    gradientUnits: "userSpaceOnUse",
    x1: 1715.3477,
    y1: 984.5325,
    x2: 1484.3593,
    y2: 918.5358
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095297374800860447040000005805646695524537532_)"
    },
    d: "M1464.411,952.777 c0,0-6.468-19.036-8.093-30.934c-1.625-11.898,4.356-38.603,9.497-46.113c5.14-7.509,6.001,10.898,8.315,19.549 c2.314,8.65-1.605,20.995-1.605,20.995l2.364,16.177L1464.411,952.777z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165207551429171634850000010607238481731541948_",
    gradientUnits: "userSpaceOnUse",
    x1: 2836.4309,
    y1: 1371.4561,
    x2: 2901.3875,
    y2: 1371.4561,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165207551429171634850000010607238481731541948_)"
    },
    d: "M566.553,1368.314 c-11.128,0.962-30.441,2.524-45.666,3.195c-9.152,0.403-14.422-0.493-17.456-1.708c0.005,0.342,0.015,0.665,0.028,0.965 c0.072,1.602,1.374,2.884,2.992,2.974c28.769,1.606,51.649,0.556,59.795,0.06c1.684-0.103,2.688-1.933,1.827-3.369 C567.642,1369.714,567.12,1369.01,566.553,1368.314z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136376643318531643070000006305116575704697017_",
    gradientUnits: "userSpaceOnUse",
    x1: 2836.4272,
    y1: 1358.7257,
    x2: 2899.5532,
    y2: 1358.7257,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136376643318531643070000006305116575704697017_)"
    },
    d: "M520.887,1371.509 c15.225-0.67,34.538-2.233,45.666-3.195c-10.941-13.423-45.666-22.469-45.666-22.469h-9.808 c-6.745,9.724-7.722,18.981-7.648,23.956C506.466,1371.015,511.735,1371.912,520.887,1371.509z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000923573315930137380000016035950105299063731_",
    gradientUnits: "userSpaceOnUse",
    x1: 2842.4282,
    y1: 1340.9519,
    x2: 2860.7251,
    y2: 1340.9519,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000923573315930137380000016035950105299063731_)"
    },
    d: "M509.428,1329.833l0.918,18.162 c0.099,1.967,1.571,3.62,3.541,3.901c1.96,0.28,4.585,0.316,7.367-0.61c1.713-0.57,2.984-2.013,3.299-3.772l3.171-17.68 H509.428z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151520651919489610350000006799469251221630617_",
    gradientUnits: "userSpaceOnUse",
    x1: 2706.9353,
    y1: 1370.0553,
    x2: 2731.8276,
    y2: 1370.0553,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151520651919489610350000006799469251221630617_)"
    },
    d: "M382.041,1371.372 c-4.826-0.673-7.009-3.18-7.924-5.86c-0.006,0.024-0.012,0.048-0.018,0.072c-0.71,2.827,0.936,5.757,4.226,7.151 c3.977,1.684,8.326,1.971,11.702,1.832c3.622-0.15,6.947-1.648,8.774-4.047l0.027-0.036 C395.192,1372.283,390.089,1372.495,382.041,1371.372z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095313071337890048780000013133857973335728280_",
    gradientUnits: "userSpaceOnUse",
    x1: 2707.1162,
    y1: 1350.8889,
    x2: 2743.6536,
    y2: 1350.8889,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000095313071337890048780000013133857973335728280_)"
    },
    d: "M404.793,1329.717h-8.088 c-12.32-0.252-20.056,25.733-22.589,35.796c0.915,2.68,3.099,5.187,7.924,5.86c8.048,1.123,13.151,0.911,16.787-0.888 c6.656-8.759,9.956-21.586,11.542-29.073C412.173,1332.897,404.793,1329.717,404.793,1329.717z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131359934741701326160000011072797267119583116_",
    gradientUnits: "userSpaceOnUse",
    x1: 2726.1077,
    y1: 1325.699,
    x2: 2747.9744,
    y2: 1325.699,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131359934741701326160000011072797267119583116_)"
    },
    d: "M397.745,1312.859l-4.491,17.863 c-0.551,2.19,0.498,4.456,2.522,5.495c2.513,1.289,6.05,2.644,9.301,2.252c1.529-0.185,2.799-1.261,3.304-2.701l6.593-18.794 L397.745,1312.859z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075864062336478870390000010131541461026512826_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.212,
    y1: 1345.1107,
    x2: 722.2136,
    y2: 906.841
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075864062336478870390000010131541461026512826_)"
    },
    d: "M392.387,1318.023 c5.588,4.956,23.763,5.611,23.763,5.611c65.469-157.133,92.251-179.456,92.251-179.456 c-9.453,59.309-1.524,190.612-1.524,190.612c10.804,4.767,24.732,0,24.732,0c0.877-97.097,15.802-181.775,33.432-248.533 c-44.249-0.995-67.78-16.137-75.464-22.214C452.692,1123.509,392.387,1318.023,392.387,1318.023z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148638005665273628210000004632446457980069785_",
    gradientUnits: "userSpaceOnUse",
    x1: 635.7673,
    y1: 863.7281,
    x2: 284.3368,
    y2: 1284.8864
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148638005665273628210000004632446457980069785_)"
    },
    d: "M500.815,883.34 c-8.375,41.777-5.374,116.55-3.402,150.656c0.554,9.586-6.138,22.875-11.547,31.941c-0.848,1.422-0.325,3.243,1.148,4 c9.056,4.654,39.734,19.079,75.29,20.873c2.371,0.12,4.488-1.495,5.102-3.788c26.374-98.479,57.009-161.408,57.009-161.408 C590.593,871.605,500.815,883.34,500.815,883.34z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133518627362142283330000015064610170834694786_",
    gradientUnits: "userSpaceOnUse",
    x1: 2799.7954,
    y1: 1244.7202,
    x2: 2810.2732,
    y2: 1223.7644,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133518627362142283330000015064610170834694786_)"
    },
    d: "M512.868,1140.458 c-0.372,0-0.748-0.101-1.089-0.307c-0.988-0.604-1.301-1.892-0.7-2.879c0.352-0.579,8.821-14.268,25.958-22.536 c1.041-0.5,2.296-0.068,2.8,0.977c0.503,1.042,0.065,2.297-0.978,2.799c-15.976,7.709-24.119,20.81-24.199,20.941 C514.265,1140.1,513.575,1140.458,512.868,1140.458z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039108094787297956060000005537905109235462025_",
    gradientUnits: "userSpaceOnUse",
    x1: 2826.2886,
    y1: 1006.9652,
    x2: 2748.4475,
    y2: 1075.8951,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039108094787297956060000005537905109235462025_)"
    },
    d: "M448.28,1003.239 c2.691,19.462,10.639,40.69,26.54,63.238l6.044-4.927c0,0-6.978-28.31-3.011-60.439 C468.044,999.198,456.46,1001.17,448.28,1003.239z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083058832139632166120000016259643298248071831_",
    gradientUnits: "userSpaceOnUse",
    x1: 587.0294,
    y1: 823.0591,
    x2: 235.5987,
    y2: 1244.2177
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083058832139632166120000016259643298248071831_)"
    },
    d: "M510.169,934.887l-9.355-51.547 c0,0-62.504,47.777-52.535,119.899c8.18-2.069,19.765-4.042,29.573-2.128C480.711,977.967,489.246,952.841,510.169,934.887z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072972725571447028400000016855262735666528936_",
    gradientUnits: "userSpaceOnUse",
    x1: 688.9907,
    y1: 908.1398,
    x2: 337.5609,
    y2: 1329.2974
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072972725571447028400000016855262735666528936_)"
    },
    d: "M624.415,925.614l-24.126,51.96 c3.901,31.37,20.753,44.933,38.923,50.136c1.133-14.297,4.748-25.847,8.102-33.837 C624.097,969.903,624.415,925.614,624.415,925.614z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059282761848176445350000007324534616786566308_",
    gradientUnits: "userSpaceOnUse",
    x1: 586.0402,
    y1: 725.4967,
    x2: 643.0373,
    y2: 924.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059282761848176445350000007324534616786566308_)"
    },
    d: "M647.314,993.873 c-3.355,7.99-6.969,19.54-8.102,33.837c48.477,18.808,61.303-17.669,61.303-17.669l-8.959-1.58 C671.323,1010.592,657.19,1004.07,647.314,993.873z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000169533355962766486470000016295675288459146943_",
    gradientUnits: "userSpaceOnUse",
    x1: 2912.6228,
    y1: 849.6607,
    x2: 2911.9534,
    y2: 964.14,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000169533355962766486470000016295675288459146943_)"
    },
    d: "M602.186,861.466l-11.647,42.818 c-1.309,4.81-6.512,7.393-11.14,5.543c-4.995-1.997-11.332-4.722-16.788-7.668c-5.823-3.144-7.645-10.635-3.959-16.131 l24.216-36.107L602.186,861.466z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148645228367610693860000006131991117063906745_",
    gradientUnits: "userSpaceOnUse",
    x1: 2742.2312,
    y1: 1058.3923,
    x2: 3063.2493,
    y2: 1058.3923,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090056"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000148645228367610693860000006131991117063906745_)"
    },
    d: "M722.733,981.389l-298.457,108.626 c-12.518,4.556-18.501,18.809-12.987,30.935l0.906,1.991c4.879,10.728,17.56,15.434,28.256,10.486l289.798-134.062 L722.733,981.389z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091010302738298881500000015152809243498272686_",
    gradientUnits: "userSpaceOnUse",
    x1: 712.5834,
    y1: 916.047,
    x2: 1007.2487,
    y2: 916.047
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.32,
      fill: "url(#SVGID_00000091010302738298881500000015152809243498272686_)"
    },
    cx: 859.916,
    cy: 916.047,
    rx: 147.333,
    ry: 144.675
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098199904878412623290000000630971378538537402_",
    gradientUnits: "userSpaceOnUse",
    x1: 3028.9746,
    y1: 916.047,
    x2: 3356.8577,
    y2: 916.047,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#020039"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#090056"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098199904878412623290000000630971378538537402_)"
    },
    d: "M859.916,755.063 c-90.542,0-163.942,72.076-163.942,160.984c0,88.91,73.399,160.984,163.942,160.984c90.542,0,163.942-72.075,163.942-160.984 C1023.858,827.138,950.458,755.063,859.916,755.063z M859.916,1053.383c-77.242,0-139.859-61.487-139.859-137.336 c0-75.849,62.617-137.336,139.859-137.336c77.242,0,139.859,61.487,139.859,137.336 C999.776,991.896,937.158,1053.383,859.916,1053.383z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125594100951541242960000012152148567198974622_",
    gradientUnits: "userSpaceOnUse",
    x1: 706.42,
    y1: 850.5093,
    x2: 942.9087,
    y2: 850.5093
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000125594100951541242960000012152148567198974622_)"
    },
    d: "M708.439,935.894 c-0.5,0-0.934-0.372-0.998-0.879c-0.485-3.793-0.828-7.675-1.019-11.535c-0.028-0.555,0.401-1.027,0.956-1.055 c0.555-0.083,1.029,0.399,1.056,0.956c0.188,3.807,0.526,7.635,1.005,11.377c0.07,0.553-0.32,1.057-0.872,1.127 C708.524,935.892,708.481,935.894,708.439,935.894z M709.565,890.88c-0.059,0-0.119-0.006-0.179-0.016 c-0.547-0.098-0.912-0.622-0.814-1.169c1.854-10.345,4.828-20.522,8.838-30.249l0.001-0.002 c23.62-57.298,79.556-94.321,142.505-94.321c29.355,0,57.89,8.155,82.521,23.581c0.471,0.295,0.614,0.917,0.319,1.389 c-0.296,0.472-0.917,0.614-1.389,0.319c-24.309-15.226-52.474-23.274-81.45-23.274c-62.129,0-117.335,36.535-140.641,93.074 c-0.001,0-0.001,0.002-0.001,0.002c-3.955,9.595-6.889,19.633-8.718,29.836C710.468,890.538,710.044,890.88,709.565,890.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113346354497917635510000007266502435534498465_",
    gradientUnits: "userSpaceOnUse",
    x1: 2857.0283,
    y1: 1041.6787,
    x2: 2779.187,
    y2: 1110.6089,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113346354497917635510000007266502435534498465_)"
    },
    d: "M478.371,1060.692l28.215-2.299 l12.219,11.264c0,0-2.891,3.996-11.929,1.699c-9.038-2.297-21.417-2.86-21.417-2.86s-12.477,5.625-12.629-4.9L478.371,1060.692z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006693197747896980160000011155424199127710140_",
    gradientUnits: "userSpaceOnUse",
    x1: 3027.0015,
    y1: 1006.2856,
    x2: 3048.9548,
    y2: 1006.2856,
    gradientTransform: "matrix(1 0 0 1 -2333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000006693197747896980160000011155424199127710140_)"
    },
    d: "M696.921,1016.716 c2.44,1.906,10.8-2.074,15.915-4.825c2.493-1.341,3.701-4.257,2.845-6.955c-1.231-3.882-3.282-8.893-5.81-9.525 C705.678,994.362,686.865,1008.86,696.921,1016.716z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000027579968502887484320000011132410501612419457_",
    gradientUnits: "userSpaceOnUse",
    x1: 415.2928,
    y1: 1105.6487,
    x2: 464.0349,
    y2: 1105.6487
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000027579968502887484320000011132410501612419457_)"
    },
    d: "M430.164,1129.158 c-0.109,0-0.22-0.018-0.33-0.055c-11.61-4.013-14.308-10.864-14.526-15.902c-0.32-7.366,4.309-14.205,11.518-17.016 l35.835-13.974c0.514-0.205,1.102,0.055,1.304,0.573c0.202,0.517-0.054,1.102-0.573,1.304l-35.835,13.974 c-6.406,2.499-10.52,8.546-10.237,15.053c0.278,6.42,4.711,11.159,13.173,14.085c0.525,0.183,0.805,0.755,0.623,1.281 C430.972,1128.896,430.581,1129.158,430.164,1129.158z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000107552357480992040700000007769708058914527138_",
    gradientUnits: "userSpaceOnUse",
    x1: 473.0619,
    y1: 1077.9369,
    x2: 479.7215,
    y2: 1077.9369
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000107552357480992040700000007769708058914527138_)"
    },
    d: "M474.07,1079.851 c-0.402,0-0.783-0.244-0.938-0.641c-0.203-0.517,0.054-1.102,0.573-1.304l4.644-1.812c0.516-0.205,1.101,0.055,1.304,0.573 c0.203,0.517-0.054,1.102-0.573,1.304l-4.644,1.812C474.315,1079.829,474.192,1079.851,474.07,1079.851z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129163338023376339210000006605054054922400690_",
    gradientUnits: "userSpaceOnUse",
    x1: 624.8245,
    y1: 820.8028,
    x2: 588.8246,
    y2: 852.8027
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000129163338023376339210000006605054054922400690_)"
    },
    d: "M604.703,819.432 c0,0,9.641,22.146,10.288,33.77c0.647,11.624,3.152,19.166-10.288,21.507c-13.44,2.341-24.762-4.355-30.896-15.933 c0,0-9.611-17.841-7.455-25.148C568.508,826.321,604.703,819.432,604.703,819.432z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143602349413485555570000015668089589214997433_",
    gradientUnits: "userSpaceOnUse",
    x1: 568.0052,
    y1: 805.6368,
    x2: 617.9105,
    y2: 869.8896
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143602349413485555570000015668089589214997433_)"
    },
    d: "M578.4,850.451h1.699 c0,0-7-14.36-0.849-16.883c6.151-2.523,30.517-7.492,35.774-16.137c5.068-8.335,0.548-19.101-6.214-22.114 c-0.428-0.191-0.932,0.01-1.151,0.425l-0.56,1.06c-0.384,0.726-1.456,0.616-1.684-0.172l0,0 c-0.216-0.748-1.225-0.911-1.636-0.25c-1.609,2.585-5.966,6.79-17.654,8.947c-16.583,3.06-27.547,9.772-27.816,21.233 c-0.017,0.726-0.793,1.126-1.413,0.748c-1.224-0.746-3.183-1.096-5.802,1.105c-4.553,3.829-2.69,13.761,7.292,21.931 c0.474,0.388,0.471,1.129-0.043,1.463c-1.81,1.178-4.507,3.981,2.483,7.718c7.15,3.822,11.381,3.405,12.978,2.997 c0.43-0.11,0.719-0.501,0.691-0.944l-0.627-10.156c-0.032-0.525,0.385-0.969,0.911-0.969H578.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086661359285075278200000017115052163773953921_",
    gradientUnits: "userSpaceOnUse",
    x1: 616.7114,
    y1: 811.675,
    x2: 580.7113,
    y2: 843.6751
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086661359285075278200000017115052163773953921_)"
    },
    d: "M578.817,852.575 c0,0-3.678-14.146-10.02-10.18c-6.343,3.966,3.291,15.851,8.39,16.38L578.817,852.575z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalaryhr);
export default __webpack_public_path__ + "static/media/salaryhr.5cea7840cb5b969ae3b7a3182be21ccf.svg";
export { ForwardRef as ReactComponent };